<template>
  <loading :active="releaseType"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots"
            :style="style">
            <!-- <div class="text-center text-blue-50 text-4xl" style="background-color:red;word-wrap:break-word; width:300px;">建立關鍵字...</div>
            <div class="w-2/4" style="background-color:blue;display: flex; justify-content: center; align-items: center; width:300px; ">
              <div style="margin: auto"> -->
                <!-- <circle-progress :percent="releasePercent" :show-percent="true" :class="'text-blue-50 text-4xl'"/> -->
                <div id="myItem5" class="ldBar label-center" data-type="fill" data-img="https://dev-private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div>
              <!-- </div>
            </div> -->
  </loading>
  <loading :active="allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <div class="flex-1 flex flex-col overflow-hidden mb-16">
    <loading :active="!showCampaignData"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <loading :active="releaseLoading"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="true"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots">
              <div class="text-center">{{releaseText}}</div><circle-progress :percent="releasePercent" :show-percent="true"/>
    </loading>
    <Header :title="showLang[selectLang]['views']['TargetEventBrowse']['page_name']" @childLang="useLang">
      <div v-if="false" class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['Event']['advertising_source']}}
      </div>
      <div v-if="false" class="grid grid-cols-4 border-2 rounded-md w-28 -ml-2" style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);">
        <img width="28" src="https://dev-private.autoturn.net/img/facebook_icon.png"/>
        <div class="mx-1 text-sm leading-7">
          Facebook
        </div>
      </div>
      <div class="mx-4 text-gray-700">
        {{showLang[selectLang]['views']['Event']['advertise_account_text']}}
      </div>
      <div class="mx-1 text-sm text-gray-400 leading-7 border-2 rounded-md px-1 -ml-2" style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);">
        {{ adaccount_name }}
      </div>
    </Header>
    <main class="flex overflow-x-hidden bg-gray-200">
      <div class="w-1/5 mx-auto p-4">
        <div class="w-full rounded-xl bg-white p-4" :style="{height: `420px`}">
          <div v-show="false" class="h-16">
            <span v-if="!isEdit" class="h-16 break-all" @click="campaignNameEdit(true)">{{campaign_name}}</span>
            <span v-if="!isEdit && campaign_name == ''" class="h-16 text-gray-400 break-all" @click="campaignNameEdit(true)">{{showLang[selectLang]['views']['Event']['campaign_name_text']}}</span>
            <textarea v-if="isEdit" id="campaignName" class="w-full border p-1" v-model="campaign_name" @blur="campaignNameEdit(false)"></textarea>
            <i class="pi pi-pencil cursor-pointer float-right" style="fontSize: 0.8rem" @click="isEdit=!isEdit"></i>
          </div>
          <hr v-show="false" class="mb-4 border-b-1 border-blueGray-200">
          <div class="space-y-4 overflow-y-auto" :style="{height: `380px`}">
            <div v-for="(item, index) in menu" :key="index">
              <div
                v-if="item?.show"
                :class="[
                  item?.open? 'text-gray-700 p-1 h-8 -mb-6' : 'text-gray-300',
                  item?.target === target? 'bg-gray-100 rounded-xl' : ''
                ]">
                <!-- <i class="pi pi-chevron-down"></i> -->
                <i class="pi pi-chevron-down block float-left mt-1.5"></i>
                <!-- <span class="mx-2">{{ item.title }}</span> -->
                <span class="mx-2 block float-left w-40 break-words">{{ item?.title }}</span>
                <i class="pi pi-lock float-right" v-if="!item?.open"></i>
              </div>
              <div class="space-y-2 ml-4 my-2 mt-7" v-if="item?.open">
                <div
                  class="text-gray-700 cursor-pointer ml-1"
                  @click="getHere(item?.target, sub?.refName, sub?.groupType)"
                  v-for="(sub, idx) in item?.submenu" :key="idx">
                  <span v-if="sub.show" class="mx-2 block w-40 break-words">{{ sub.title }}</span>
                  <i class="pi pi-check-circle float-right" v-if="sub.checked"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="edit_content" ref="scrollcontent" class="w-4/5 mx-auto p-4 overflow-y-auto">
        <div v-show="target == 1">
          <CampaignName ref="childCampaignName" v-bind:editPage="cancelEdit" v-model:viewDatalist="campaign_name" @childCampaignName="campaignData" v-bind:lang="showLang[selectLang]" v-bind:useDefaultLayout="useDefaultLayout" />
          <BenefitsAndInvestment ref="childBenefitAndContribution" v-bind:editPage="cancelEdit" v-bind:viewDatalist="benefitsAndInvestmentData" v-bind:lang="showLang[selectLang]" />
          <Regions ref="childRegions" v-bind:editPage="cancelEdit" v-bind:viewDatalist="regionsData" v-bind:targetDM="showTargetDM" v-model:selectCountries="selectCountries" v-model:selectLangs="selectLangs" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
          <PositionAndDevice ref="childPositionDevice" v-bind:editPage="cancelEdit" v-bind:viewDatalist="pdData" v-bind:autoPublisher="auto_publisher" v-bind:publisherPlatforms="publisher_platforms" v-bind:lang="showLang[selectLang]" @checkClose="changeYoutubeType" @childYoutube="childYoutube" v-bind:youtubeClose="youtubeClose" />
          <Relationship v-if="false" ref="childRelationship" v-bind:showRelationship="showRelationship" v-bind:editPage="cancelEdit" v-bind:viewDatalist="exAudiencesData" v-bind:campaignId="campaign_id" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" />
        </div>
        <div v-show="target == 2">
          <div v-show="showTargetCR != true && showOtherTargetCR != true && useDefaultLayout === null">
            <OptimizationMethod ref="childOptimizationMethod" v-bind:editPage="cancelEdit" v-model:viewDatalist="optimizedData" @childCampaignName="campaignData" v-bind:lang="showLang[selectLang]" v-bind:useDefaultLayout="useDefaultLayout" @childSelectTypeValue="childSelectTypeValue"/>
            <GoalsAndBudget ref="childGoalsAndBudget" v-bind:showGoalsAndBudget="showGoalsAndBudget" v-bind:editPage="cancelEdit" v-bind:viewDatalist="goalsData" v-bind:getDate="returnGapTime" v-bind:budgetKWTotal="budgetKW" v-bind:useEndDate="returnUseEndDate" v-bind:formMinAddition="updateMinAddition" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:useLang="selectLang" v-bind:youtubeClose="youtubeClose" v-bind:targetType="optimizedData.mode" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childObjective="goalsObjective" @childObjectiveOption="objectiveOption"/>
            <Identity ref="childIdentity" v-bind:showIdentity="showIdentity" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childPageId="eventPageId" />
            <Material ref="childMaterial" v-if="showMaterial" v-bind:editPage="cancelEdit" v-bind:viewDatalist="postData" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:campaignId="campaign_id" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:targetType="optimizedData.mode" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childActiveScroll="activeScroll" />
            <AdvertisingMaterial ref="childCustomizeMaterial" v-bind:editPage="cancelEdit" v-model:viewDatalist="adMaterialDataNew" v-bind:pageId="formPageId" v-bind:goalsObjective="getGoalsObjective" v-bind:changeFormId="changeFormId" v-bind:changeMessageId="changeMessageId" v-bind:lang="showLang[selectLang]" @childFormId="eventFormId" @childMessageId="eventMessageId" @childContent="adMaterialContent" :style="showAdvertisingMaterial ? '' : 'display:none;'" />
            <Form v-if="showForm" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:pageId="formPageId" v-bind:firstFormId="first_form_id" v-bind:formStatus="form_status" v-bind:formId="formId" v-bind:useTeachDetail="use_teach_detail" v-bind:selectLang="selectLang" v-bind:lang="showLang[selectLang]" @childChangeFormId="formChangeFormId" />
            <Msg v-if="showMsg" v-bind:editPage="cancelEdit" v-bind:viewDatalist="idData" v-bind:pageId="formPageId" v-bind:firstMessageId="first_message_id" v-bind:messageStatus="message_status" v-bind:messageId="messageId" v-bind:useTeachDetail="use_teach_detail" v-bind:lang="showLang[selectLang]" @childChangeMessageId="formChangeMessageId" />
            <MarketingDate ref="childBudgetSchedule" v-bind:showMarketingDate="showMarketingDate" v-bind:editPage="cancelEdit" v-bind:viewDatalist="dateData" v-bind:currencyList="currencyData" v-bind:lang="showLang[selectLang]" v-bind:youtubeClose="youtubeClose" v-bind:targetType="optimizedData.mode" v-bind:efficientAi="efficientAi" @checkClose="changeYoutubeType" @childYoutube="childYoutube" @childGapTime="dateGapTime" @childEndTime="dateEndTime" @childUseEndDate="dateUseEndDate" />
          </div>
        </div>
      </div>
    </main>
    <footer class="block bg-white fixed w-full bottom-0">
      <div class="h-1 bg-green-700 progressbar" style="width:20%" :style="{width: `${process}%`}"></div>
      <div class="mx-auto pl-8 pr-28 py-4">
        <div class="flex flex-wrap items-center md:justify-between justify-center">
          <div class="border-gray-400 space-x-2">
            <button
              class="bg-blue-600 hover:bg-blue-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-white transition duration-500 ease-in-out border-2 border-blue-400"
              @click="form_update()"
              >確認修改</button>
            <button
              v-if="false"
              class="bg-yellow-300 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out border-2 border-yellow-400"
              @click="release()"
              >{{showLang[selectLang]['views']['Event']['release_button']}}</button>
          </div>
          <div class="border-gray-400 space-x-2">
            <span>{{showLang[selectLang]['views']['Event']['process_text_a']}} {{process}} % <span v-if="process == 66">{{showLang[selectLang]['views']['Event']['process_text_b']}}</span></span>
          </div>
          <div class="border-gray-400 space-x-2 mr-16">
            <button
              v-if="this.target != 1"
              class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
              @click="prev()"
              :disabled="process <= 0"
            >{{showLang[selectLang]['views']['Event']['prev_text']}}</button>
            <button
              v-if="this.target != 2"
              class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
              @click="next()"
            >{{showLang[selectLang]['views']['Event']['next_text']}}</button>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import CampaignName from '@/components/TargetEvent/CampaignName.vue'
  import BenefitsAndInvestment from '@/components/TargetEvent/BenefitsAndInvestment.vue'
  import MarketingDate from '@/components/TargetEvent/MarketingDate.vue'
  import OptimizationMethod from '@/components/TargetEvent/OptimizationMethod.vue'
  import GoalsAndBudget from '@/components/TargetEvent/GoalsAndBudget.vue'
  import Regions from '@/components/TargetEvent/Regions.vue'
  import Identity from '@/components/TargetEvent/Identity.vue'
  import Relationship from '@/components/TargetEvent/Relationship.vue'
  import PositionAndDevice from '@/components/TargetEvent/PositionAndDevice.vue'
  import Material from '@/components/TargetEvent/Material.vue'
  import AdvertisingMaterial from '@/components/TargetEvent/AdvertisingMaterial.vue'
  import Form from '@/views/Form.vue'
  import Msg from '@/views/Msg.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import CircleProgress from "vue3-circle-progress";
  import axios from 'axios'
  import Qs from 'qs'
  import lang from '@/language/lang.json'
  import { reactive, toRaw } from 'vue';

  export default {
    name: 'Home',
    components: {
      Header,
      CampaignName,
      BenefitsAndInvestment,
      MarketingDate,
      OptimizationMethod,
      GoalsAndBudget,
      Regions,
      Identity,
      Relationship,
      PositionAndDevice,
      Material,
      AdvertisingMaterial,
      Form,
      Msg,
      Loading,
      CircleProgress
    },
    data() {
      return {
        selectLang: 'zh-TW',
        showLang: lang,
        use_teach_detail: false, // <!-- 新手教學 -->
        showCampaignData: false,
        showMarketingDate: true,
        showAdvertisingMix: 'true_0000',
        showRemarketingMix: 'true_0000',
        showGoalsAndBudget: true,
        showRelationship: true,
        showIdentity: true,
        db_writing_status: 'key',
        db_status: 'N',
        display: false,
        cancelEdit: true,
        process: 0,
        showTargetKW: true,
        showTargetDM: true,
        showTargetLA: true,
        showTargetRT: true,
        showTargetCF: true,
        showTargetAD: true,
        showTargetCR: true,
        showOtherTargetCR: false,
        returnGapTime: null,
        returnEndTime: null,
        returnUseEndDate: null,
        budgetKW:null,
        updateMinAddition: 0,
        getGoalsObjective: null,
        showMaterial:true,
        showStageMaterial:null,
        showAdvertisingMaterial:true,
        showStageAdvertisingMaterial:null,
        showForm:true,
        showStageForm:null,
        showMsg:true,
        showStageMsg:null,
        isEdit: false,
        campaign_id: null,
        campaign_name: null,
        adaccount_id: null,
        productUrl: null,
        adaccount_name: null,
        target: 1,
        formPixelId: null,
        formPageId: null,
        formId: null,
        messageId: null,
        changeFormId: null,
        changeMessageId: null,
        menu: [],
        _tmpMenu: [],
        Budget_KW_result: null,
        total_budget: null,
        currencyData: {
                      currency: '',
                      currency_name: null,
                      currency_symbol: null,
                      currency_min_price: null,
                      currency_video_min_price: null,
                      currency_suggest_price: null,
                      currency_remarketing_price: null,
                      currency_offset: 1,
                    },
        methodData: {
                    Target_KW:null,
                    Budget_KW:null,
                    Target_DM:null,
                    Budget_DM:null,
                    Target_LA:null,
                    Budget_LA:null,
                    Target_RT:null,
                    Budget_RT:null,
                    use_similar_audience_status:0,
                    use_confldential_audience_status:0,
                    Target_CF:null,
                    Budget_CF:null,
                    Target_AD:null,
                    Budget_AD_min:null,
                    Budget_AD_max:null,
                    Target_CR:null,
                    Other_Target_CR:null,
                    retargeting:null,
                    daily_budget:null
                  },
        benefitsAndInvestmentData: {
          useFinance: false,
          toTaiwan: false,
          regulated_country: null,
          country_options: [],
          benefits: null,
          benefits_list: [],
          investment: null,
          investment_list: [],
          person_or_business: {label : '個人或商家驗證', value : 1},
          beneficiary_id: null,
          payer_id: null,
          beneficiary_name: null,
          payer_name: null,
          beneOrPayerPersonalList:[],
          selectedBeneficiary: null,
          selectedPayer: null,
          showKeyinBeneficiary: null,
          showKeyinPayer: null,
        },
        otherCustomTitle:[],
        defaultLayout: [],
        defaultStage: [],
        stageMenu: [],
        formCampaignHaveTest: true,
        optimizedData: {
          mode: 'fix'
        },
        dynBudgetData: {
          useDynamicBudget: false
        },
        doForwardData: {
          useDoForward: false
        },
        dateData: {
                    budgetType: "sum",
                    budgetTypeList:[
                      {name: "總預算", code: "sum"}, 
                      {name: "單日預算", code: "day"}, 
                    ],
                    targetMonSales: null,
                    start_date:null,
                    end_date:null,
                    use_end_date:null,
                  },
        goalsData: {
                    campaign_objective:null,
                    objective_option:null,
                    objective_list:null,
                    product_catalog_list:null,
                    product_set_list:null,
                    optimization_action:null,
                    optimization_goal:null,
                    product_catalog_id:null,
                    product_set_id:null,
                    pixel_id:null,
                    pixel_event:null,
                    conversion_domain:null,
                    domain_list:null,
                    useAppEvent: false,
                    appItemsSelected: null,
                    appItemsList: [],
                    effect:null,
                    currency_video_min_price:null,
                    form_addition:null,
                    use_addition:null,
                    risk_automatic:null,
                    risk_index:null,
                    risk_level_list:null,
                    risk_level:null
                  },
        regionsData: {
                      location_types:null,
                      locations:null,
                      location_range:null,
                      locales:null,
                      gender:null,
                      age_min:null,
                      age_max:null
                    },
        selectCountries: null,
        selectLangs: null,
        exAudiencesData: {
                      excluded_audiences:null,
                      default_excluded_audiences:null,
                      custom_excluded_audiences:null,
                      custom_excluded_audiences_selected:null,
                    },
        pdData: {
                  auto_publisher:null,
                  publisher_platforms:null,
                  publisher_platforms_list:null,
                  device_platforms: null,
                  user_os:null,
                  user_os_list:null,
                },
        auto_publisher: null,
        publisher_platforms: null,
        idData: {
                  page_id:null,
                  ig_id:null,
                  ig_username:null,
                  adpages_list:null,
                  ig_list:null,
                },
        postData: {
                  page_id:null,
                  special_ad_category:null,
                  disabled_creative_optimize:false,
                  creative_optimize:false,
                  select_article:null,
                  db_select_article:null,
                  db_select_creatives:null,
                  select_creatives_message:null,
                  select_creatives:null,
                  db_select_creatives_message:null,
                  select_creatives_adset_ads:null,
                  db_select_creatives_adset_ads:null,
                  select_creatives_adset_ads_message:null,
                  db_select_creatives_adset_ads_message:null,
                },
        adMaterialData: {
                          disabled_creative_optimize:false,
                          creative_optimize:false,
                          creative_array:null,
                        },
        tmpAdMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        adMaterialDataNew:{
                            disabled_creative_optimize:false,
                            creative_optimize:false,
                            creative_array:null,
                          },
        formData: {
                    pageId: null,
                    formId: null
                  },
        msgData: {
                    pageId: null,
                    msgId: null
                  },
        first_form_id: null,
        form_status: null,
        first_message_id: null,
        message_status: null,
        AdvertisingMaterialStatus: undefined,
        releaseType: true,
        efficientAi: null,
        style: 'z-index: -1;',
        releaseText: '發佈中...',
        releasePercent: 0,
        allPageLoading: false,
        youtubeClose: false,
        isClass: 'n',
        haveASC: 'false_',
        otherCustomCampaignId: null,
        subCampaignList: [],
        nextLoading: false,
        useDefaultLayout: null,
        targetType: 'fix',
        targetAllocation: true,
      }
    },
    created() {
      // console.log('id:'+this.$route.params.id);
      // console.log('adaccount_id:'+this.$route.params.adaccount_id);
      // console.log('campaign_id:'+this.$route.params.campaign_id);

      let hash = this.$route.params.id;

      if(hash != '' && hash != null && typeof hash != 'undefined'){
        axios
          .post('https://test.autoturn.net/inside/api/member_info.php', Qs.stringify({
            s_code: this.$route.params.id,
          }))
          .then((adResponse) => {
            // console.log('adResponse:'+adResponse.data.selecded_data);
            console.log('sidebar member_info.php');
            if(adResponse.data.status == 'success'){

              if(adResponse.data.return_data.source == 6 && (adResponse.data.return_data.payment_plan_id == 1 || adResponse.data.return_data.account_status == 's')){
                this.isClass = 'y';
              }

            } else {
              Swal.fire({
                icon: 'error',
                title: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_title'],
                text: adResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  // this.allPageLoading = true
                  window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                }
              })
            }
          });

        // this.initializeData();

        axios
          .post('https://test.autoturn.net/inside/api/lib/default_stage.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
          }))
          .then((dsResponse) => {
            // console.log('dsResponse:'+dsResponse.data.selecded_data);
            console.log('lib default_stage.php');
            console.log(dsResponse.data);
            if(dsResponse.data.status == 'success'){
              this.defaultStage = dsResponse.data.return_data;
              this.stageMenu = dsResponse.data.menu;

              console.log('this.defaultStage');
              console.log(this.defaultStage);
              console.log('this.stageMenu');
              console.log(this.stageMenu);

              axios
                .post('https://test.autoturn.net/inside/api/target/campaign/campaign.php', Qs.stringify({
                  s_code: this.$route.params.id,
                  adaccount_id: this.$route.params.adaccount_id,
                  campaign_id: this.$route.params.campaign_id
                }))
                .then((response) => {
                  if(response.data.status == 'success'){
                    this.campaign_id = this.$route.params.campaign_id
                    this.campaign_name = response.data.return_data.campaign_name
                    this.adaccount_id = response.data.return_data.adaccount_id
                    this.adaccount_name = response.data.return_data.adaccount_name
                    this.productUrl = response.data.return_data.product_url

                    document.title = response.data.return_data.campaign_name+' - '+this.showLang[this.selectLang]['views']['TargetEvent']['created']['page_title']+' - AutoTurn';

                    console.log('b this.showTargetCR');
                    console.log(this.showTargetCR);

                    this.showTargetKW = response.data.return_data.Target_KW;
                    // this.showTargetLA = response.data.return_data.Target_LA
                    this.showTargetLA = false;
                    this.showTargetRT = response.data.return_data.Target_RT;
                    this.showTargetAD = response.data.return_data.Target_AD;
                    this.showTargetCR = response.data.return_data.Target_CR;
                    this.formCampaignHaveTest = response.data.return_data.haveTest;

                    this.benefitsAndInvestmentData = {
                      toTaiwan: response.data.return_data.toTaiwan,
                      regulated_country: response.data.return_data.regulated_country,
                      country_options: response.data.return_data.country_options,
                      useFinance: response.data.return_data.useFinance,
                      benefits: response.data.return_data.benefits,
                      benefits_list: response.data.return_data.benefits_list,
                      investment: response.data.return_data.investment,
                      investment_list: response.data.return_data.investment_list,
                      person_or_business: response.data.return_data.person_or_business,
                      beneficiary_id: response.data.return_data.beneficiary_id,
                      payer_id: response.data.return_data.payer_id,
                      beneficiary_name: response.data.return_data.beneficiary_name,
                      payer_name: response.data.return_data.payer_name,
                      beneOrPayerPersonalList: response.data.return_data.beneficiary_or_payer_personal_list,
                      selectedBeneficiary: response.data.return_data.selected_beneficiary,
                      selectedPayer: response.data.return_data.selected_payer,
                      showKeyinBeneficiary: response.data.return_data.show_keyin_beneficiary,
                      showKeyinPayer: response.data.return_data.show_keyin_payer,
                    };

                    console.log('a this.benefitsAndInvestmentData');
                    console.log(this.benefitsAndInvestmentData);

                    this.useDefaultLayout = response.data.return_data.use_Default_Layout;

                    console.log('response.data.return_data.Target_CR');
                    console.log(response.data.return_data.Target_CR);
                    console.log('a this.showTargetCR');
                    console.log(this.showTargetCR);

                    this.optimizedData = {
                      mode: response.data.return_data.optimized_mode
                    };

                    this.defaultLayout = response.data.return_data.default_layout;

                    if(this.showTargetCR == true || this.useDefaultLayout !== null){
                      console.log('#00');
                      let subCampaigns = response.data.return_data.sub_campaigns;
                      this.subCampaignList = response.data.return_data.sub_campaigns;

                      this.menu = [
                        {
                          title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_title'],
                          submenu: [
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_1_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_2_title'], show: true, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], show: false, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], show: false, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], show: false, checked: false},
                            {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_6_title'], show: true, checked: false},
                          ],
                          open: true,
                          show: true,
                          target: 1
                        },
                      ];

                      this.otherCustomTitle = response.data.return_data.other_subset_data;
                    }

                    let startTime = response.data.return_data.start_date;
                    let endTime = response.data.return_data.end_date;
                    let diffType = 'day';

                    let gapTime = 0;

                    if(startTime != '' && startTime != '0000-00-00' && startTime != null && endTime != '' && endTime != '0000-00-00' && endTime != null){
                      diffType = diffType.toLowerCase();
                      var sTime =new Date(startTime); //開始時間
                      var eTime =new Date(endTime); //結束時間
                      //作為除數的數字
                      var timeType = 1;
                      switch (diffType) {
                          case"second":
                              timeType =1000;
                          break;
                          case"minute":
                              timeType =1000*60;
                          break;
                          case"hour":
                              timeType =1000*3600;
                          break;
                          case"day":
                              timeType =1000*3600*24;
                          break;
                          default:
                          break;
                      }
                      gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
                    }

                    this.budgetKW = response.data.return_data.Budget_KW;
                    this.returnGapTime = gapTime;
                    this.returnEndTime = response.data.return_data.end_date;
                    this.returnUseEndDate = response.data.return_data.use_end_date;
                    this.Budget_KW_result = response.data.return_data.Budget_KW_result;
                    this.total_budget = response.data.return_data.total_budget;

                    this.currencyData = {
                                          currency: response.data.return_data.currency,
                                          currency_name: response.data.return_data.currency_name,
                                          currency_symbol: response.data.return_data.currency_symbol,
                                          currency_min_price: response.data.return_data.currency_min_price,
                                          currency_video_min_price: response.data.return_data.currency_video_min_price,
                                          currency_suggest_price: response.data.return_data.currency_suggest_price,
                                          currency_remarketing_price: response.data.return_data.currency_remarketing_price,
                                          KW_min_price: response.data.return_data.KW_min_price,
                                          DM_min_price: response.data.return_data.DM_min_price,
                                          LA_min_price: response.data.return_data.LA_min_price,
                                          RT_min_price: response.data.return_data.RT_min_price,
                                          currency_offset: response.data.return_data.offset,
                                        }

                    let _tmp_Target_LA = response.data.return_data.Target_LA;
                    let _tmp_Budget_LA = response.data.return_data.Budget_LA;
                    // if(_tmp_Target_LA == '1'){
                    //   _tmp_Target_LA = false;
                    //   _tmp_Budget_LA = 0;

                    //   Swal.fire(
                    //               this.showLang[this.selectLang]['views']['Event']['created']['LA_swal_title'],
                    //               this.showLang[this.selectLang]['views']['Event']['created']['LA_swal_text'],
                    //               'warning'
                    //             )
                    // }

                    console.log('response.data.return_data.daily_budget');
                    console.log(response.data.return_data.daily_budget);

                    this.methodData = {
                                        Target_KW : response.data.return_data.Target_KW,
                                        Budget_KW : response.data.return_data.Budget_KW,
                                        Target_DM : response.data.return_data.Target_DM,
                                        Budget_DM : response.data.return_data.Budget_DM,
                                        Target_LA : response.data.return_data.Target_LA,
                                        Budget_LA : response.data.return_data.Budget_LA,
                                        Target_RT : response.data.return_data.Target_RT,
                                        Budget_RT : response.data.return_data.Budget_RT,
                                        Target_CF : response.data.return_data.Target_CF,
                                        Budget_CF : response.data.return_data.Budget_CF,
                                        Target_AD : response.data.return_data.Target_AD,
                                        Budget_AD_min : response.data.return_data.Budget_AD_min,
                                        Budget_AD_max : response.data.return_data.Budget_AD_max,
                                        Target_CR : response.data.return_data.Target_CR,
                                        Other_Target_CR : false,
                                        use_similar_audience_status : response.data.return_data.use_similar_audience_status,
                                        use_confldential_audience_status : response.data.return_data.use_confldential_audience_status,
                                        retargeting : response.data.return_data.retargeting,
                                        daily_budget : response.data.return_data.daily_budget
                                      }

                    console.log('this.methodData');
                    console.log(this.methodData);
                    console.log('response.data.return_data.Target_LA');
                    console.log(response.data.return_data.Target_LA);
                    console.log('b showAdvertisingMix');
                    console.log(this.showAdvertisingMix);

                    if(response.data.return_data.Target_LA == '1'){

                      var todayForm = new Date();
                      var yearForm = todayForm.getFullYear();
                      var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      let get_value_la = 'false_'+yearForm + monthForm + dateForm + timeForm;

                      this.showAdvertisingMix = get_value_la;
                    }

                    console.log('a showAdvertisingMix');
                    console.log(this.showAdvertisingMix);

                    if(response.data.return_data.Target_RT == '1'){

                      var todayForm = new Date();
                      var yearForm = todayForm.getFullYear();
                      var dateForm = String(todayForm.getDate()).padStart(2, '0');
                      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                      let get_value_rt = 'false_'+yearForm + monthForm + dateForm + timeForm;

                      this.showRemarketingMix = get_value_rt;
                    }

                    this.dynBudgetData = {
                      useDynamicBudget: response.data.return_data.use_dynamic_budget,
                    }

                    this.doForwardData = {
                      useDoForward: response.data.return_data.use_do_forward,
                    }

                    this.dateData = {
                                      budgetType: response.data.return_data.budget_type,
                                      budgetTypeList:response.data.return_data.budget_type_list,
                                      targetMonSales: response.data.return_data.budget_sales,
                                      start_date : response.data.return_data.start_date,
                                      end_date : response.data.return_data.end_date,
                                      use_end_date : response.data.return_data.use_end_date
                                    }

                    this.goalsData = {
                                        campaign_objective : response.data.return_data.campaign_objective,
                                        objective_option : response.data.return_data.objective_option,
                                        objective_list : response.data.return_data.objective_list,
                                        product_catalog_list : response.data.return_data.product_catalog_list,
                                        product_set_list : response.data.return_data.product_set_list,
                                        optimization_action : response.data.return_data.optimization_action,
                                        optimization_goal : response.data.return_data.optimization_goal,
                                        product_catalog_id : response.data.return_data.product_catalog_id,
                                        product_set_id : response.data.return_data.product_set_id,
                                        useAppEvent: response.data.return_data.useAppEvent,
                                        appItemsSelected: response.data.return_data.appItemsSelected,
                                        appItemsList: response.data.return_data.appItemsList,
                                        pixel_id : response.data.return_data.pixel_id,
                                        pixel_event : response.data.return_data.pixel_event,
                                        conversion_domain : response.data.return_data.conversion_domain,
                                        domain_list: response.data.return_data.domain_list,
                                        effect : response.data.return_data.effect,
                                        currency_video_min_price: response.data.return_data.currency_video_min_price,
                                        form_addition : response.data.return_data.form_addition,
                                        use_addition : response.data.return_data.use_addition,
                                        risk_automatic : response.data.return_data.risk_automatic,
                                        risk_index : response.data.return_data.risk_index,
                                        risk_level_list: response.data.return_data.risk_level_list,
                                        risk_level: response.data.return_data.risk_level,
                                        targetMonSales: response.data.return_data.target_mon_sales,
                                      }

                    this.getGoalsObjective = response.data.return_data.campaign_objective;

                    console.log('this.goalsData');
                    console.log(this.goalsData);

                    console.log('b this.regionsData');
                    console.log(this.regionsData);

                    this.regionsData = {
                                          location_types : response.data.return_data.location_types,
                                          location_item : response.data.return_data.location_item,
                                          locations : response.data.return_data.locations,
                                          location_range : response.data.return_data.location_range,
                                          locales : response.data.return_data.locales,
                                          gender : response.data.return_data.gender,
                                          age_min : response.data.return_data.age_min,
                                          age_max : response.data.return_data.age_max,
                                        }

                    console.log('a this.regionsData');
                    console.log(this.regionsData);

                    this.selectCountries = response.data.return_data.locations

                    this.selectLangs = response.data.return_data.locales

                    this.exAudiencesData = {
                                              excluded_audiences : response.data.return_data.excluded_audiences,
                                              default_excluded_audiences : response.data.return_data.default_excluded_audiences,
                                              custom_excluded_audiences : response.data.return_data.custom_excluded_audiences,
                                              custom_excluded_audiences_selected : response.data.return_data.custom_excluded_audiences_selected,
                                            }

                    this.pdData = {
                                    auto_publisher : response.data.return_data.auto_publisher,
                                    publisher_platforms : response.data.return_data.publisher_platforms,
                                    publisher_platforms_list : response.data.return_data.publisher_platforms_list,
                                    device_platforms: response.data.return_data.device_platforms,
                                    user_os : response.data.return_data.user_os,
                                    user_os_list : response.data.return_data.user_os_list
                                  }

                    this.auto_publisher = response.data.return_data.auto_publisher
                    this.publisher_platforms = response.data.return_data.publisher_platforms

                    this.idData = {
                                    page_id : response.data.return_data.page_id,
                                    ig_id : response.data.return_data.ig_id,
                                    ig_username : response.data.return_data.ig_username,
                                    adpages_list : response.data.return_data.adpages_list,
                                    ig_list : response.data.return_data.ig_list,
                                  }

                    this.postData = {
                                      page_id : response.data.return_data.page_id,
                                      special_ad_category : response.data.return_data.special_ad_category,
                                      disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                      creative_optimize : response.data.return_data.creative_optimize,
                                      creative_optimize: response.data.return_data.creative_optimize,
                                      db_select_article : response.data.return_data.post_ids,
                                      db_select_creatives : response.data.return_data.creatives_ids,
                                      db_select_creatives_message : response.data.return_data.creatives_message_ids,
                                      db_select_creatives_adset_ads : response.data.return_data.creatives_ids_adset_ads,
                                      db_select_creatives_adset_ads_message : response.data.return_data.creatives_adset_ads_message,
                                    }

                    console.log('db_select_creatives_adset_ads_message');
                    console.log(response.data.return_data.creatives_adset_ads_message);
                    // console.log('b this.postData');
                    // console.log(this.postData);

                    // if(response.data.return_data.campaign_objective == 'PRODUCT_CATALOG_SALES'){
                    //   this.postData.db_select_creatives_adset_ads = response.data.return_data.creatives_ids_adset_ads;
                    // } else {
                    //   this.postData.db_select_creatives = response.data.return_data.creatives_ids;
                    // }

                    console.log('a this.postData');
                    console.log(this.postData);

                    this.adMaterialData = {
                                            disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                            creative_optimize: response.data.return_data.creative_optimize,
                                            creative_array : response.data.return_data.creative_array,
                                          }

                    this.tmpAdMaterialDataNew = {
                                                  disabled_creative_optimize : response.data.return_data.disabled_creative_optimize,
                                                  creative_optimize: response.data.return_data.creative_optimize,
                                                  creative_array : response.data.return_data.creative_array
                                                }

                    this.formPixelId = response.data.return_data.pixel_id

                    this.formPageId = response.data.return_data.page_id

                    this.first_form_id = response.data.return_data.first_form_id

                    this.form_status = response.data.return_data.form_status

                    this.first_message_id = response.data.return_data.first_message_id

                    this.message_status = response.data.return_data.message_status

                    this.db_writing_status = response.data.return_data.writing_status

                    this.db_status = response.data.return_data.status

                    console.log('load this.adMaterialData');
                    console.log(this.adMaterialData);
                    console.log('load this.tmpAdMaterialDataNew');
                    console.log(this.tmpAdMaterialDataNew);

                    if(response.data.return_data.creative_array.length > 0){
                      this.showAdvertisingMaterial = true;
                      this.showMsg = true;
                    } else {
                      this.showAdvertisingMaterial = false;
                      this.showMsg = false;
                    }

                    // console.log('response.data.return_data.form_addition:'+response.data.return_data.form_addition);
                    // console.log('b this.goalsData:'+this.goalsData.form_addition);
                    this.minAddition(response.data.return_data.form_addition, gapTime, response.data.return_data.Budget_KW, this.returnUseEndDate);
                    // console.log('a this.goalsData:'+this.goalsData.form_addition);
                  }

                  if(response.data.status == 'login'){
                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['Event']['created']['login']['swal_title'],
                      text: this.showLang[this.selectLang]['views']['Event']['created']['login']['swal_text'],
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['created']['login']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        // this.allPageLoading = true
                        window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        // this.allPageLoading = true
                        window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                      }
                    })
                  }

                  console.log('return this.showTargetCR');
                  console.log(this.showTargetCR);
                  if(this.showTargetCR == false && this.useDefaultLayout === null){
                    this.showCampaignData = true;
                  }
                });
            }
          });
      } else {
        Swal.fire({
          icon: 'error',
          title: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_title'],
          text: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_text'],
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['created']['no_hash_swal_confirm_button']
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            // Swal.fire('Saved!', '', 'success')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            // this.allPageLoading = true
            window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
          }
        })
      }
    },
    watch:{
      // 'formPageId': function(v){
      //   console.log('event formPageId');
      //   console.log(v);
      // },
      // 'idData.page_id': function(v){
      //   console.log('event idData.page_id');
      //   console.log(v);
      // }
      AdvertisingMaterialStatus(status) {
        // console.log('watch AdvertisingMaterialStatus');
        // console.log(status);
        if (status) {
          // console.log(status);
          this.$nextTick().then(() =>
            this.$refs.scrollcontent.scrollTo({
              top: 1505,
              behavior: 'smooth'
            })
          );
        }
      },
      sub_campaigns(v){
        console.log('sub_campaigns');
        console.log(v);
      },
      'menu':function(v){
        console.log('menu content');
        console.log(v);
      },
    },
    methods: {
      childSelectTypeValue(value){
        console.log('childSelectTypeValue', value);

        this.targetType = value;

        if(value == 'target'){
          this.targetAllocation = false
          this.showTargetKW = true
          this.showTargetLA = true
          this.showTargetRT = true
        } else {
          this.targetAllocation = true
          this.showTargetKW = false
          this.showTargetLA = false
          this.showTargetRT = false
        }
      },
      delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      changeYoutubeType(){
        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        this.youtubeClose = 'false_'+todayForm;

        console.log('eventadd changeYoutubeType');
        console.log(this.youtubeClose);
      },
      childYoutube(v){
        this.youtubeClose = v;
      },
      useLang(v){
        console.log('event methods useLang');
        console.log(v);

        if(v == '' || v == null || typeof v == 'undefined'){
          v = 'zh-TW';
        }

        this.selectLang = v

        this.$emit('childLang', v);

        console.log('this.selectLang', this.selectLang);
        console.log('this.showTargetCR', this.showTargetCR);
        console.log('this.showOtherTargetCR', this.showOtherTargetCR);
        console.log('b this.menu', this.menu);
        // console.log('showLang['+v+'][msg]');
        // console.log(this.showLang[v]['msg']);

        this.menu = [
          {
            title: '基本設定',
            submenu: [
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_0_title'], groupType: 'childCampaignName', refName: 'campaignName', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_8_title'], groupType: 'childBenefitAndContribution', refName: 'benefitAndContribution', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_2_title'], groupType: 'childRegions', refName: 'regions', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_1_title'], groupType: 'childPositionDevice', refName: 'positionDevice', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 1
          },
          {
            title: '策略目標設定',
            submenu: [
              {title: '優化方式', groupType: 'childOptimizationMethod', refName: 'optimizationMethod', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_2_submenu_1_title'], groupType: 'childGoalsAndBudget', refName: 'goalsAndBudget', show: true, checked: false},
              {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_2_title'], groupType: 'childIdentity', refName: 'identity', show: true, checked: false},
              {title: '素材相關設定', groupType: 'childMaterial', refName: 'material', show: true, checked: false},
              // {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_3_submenu_4_title'], groupType: 'childCustomizeMaterial', refName: 'customizeMaterial', show: true, checked: false},
              {title: '預算走期', groupType: 'childBudgetSchedule', refName: 'budgetSchedule', show: true, checked: false},
            ],
            open: true,
            show: true,
            target: 2
          },
          // {
          //   title: '關鍵字與受眾設定',
          //   submenu: [
          //     {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_3_title'], groupType: 'childKeywordMix', refName: 'keywordMix', show: true, checked: false},
          //     {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_4_title'], groupType: 'childAdvertisingMix', refName: 'advertisingMix', show: true, checked: false},
          //     {title: this.showLang[this.selectLang]['views']['Event']['menu']['step_1_submenu_7_title'], groupType: 'childRemarketingMix', refName: 'remarketingMix', show: true, checked: false},
          //   ],
          //   open: true,
          //   show: true,
          //   target: 3
          // },
        ];

        console.log('a this.menu', this.menu);
      },
      campaignData(value){
        console.log('campaignData'+value);
        this.campaign_name = value
      },
      campaignNameEdit(type){
        // console.log('campaignNameEdit');

        this.isEdit = type;

        // if(type == true){
        //   console.log('鎖定');
        //   document.getElementById("campaignName").focus();
        //   this.$refs.campaignName.focus();
        // }
      },
      minAddition(budgetAddition, day, budgetKW, useEndDate){
        // console.log('value budgetAddition:'+budgetAddition);

        // console.log('getDate budgetAddition:'+day);
        // console.log('budgetKWTotal budgetAddition:'+budgetKW);
        // console.log('useEndDate budgetAddition:'+useEndDate);

        // if(useEndDate == false){
        //   //有結束日期
        //   // console.log('有結束日期');
        //   //先算精準興趣總預算

        //   if(!isNaN(day) && day > 0){
        //     // console.log('有日期間距');
        //     var _tmp_days = day;
        //     var _tmp_total = budgetKW;
        //     // var _tmp_budget_addition = (budget_addition == '' || budget_addition == 0)?0:budget_addition/100
        //     var _tmp_interval_week = 0;
        //     var interval_week = 0;
        //     var n = 0;
        //     var html = 0;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var _tmp_budget_addition = video_min_price;

        //     let _test_total = 0;

        //     if(_tmp_days > 0){
        //         if(_tmp_days > 3){
        //             n = Math.round(_tmp_days/7);
        //         }
        //     }

        //     //console.log(_tmp_total+'*7');
        //     var first_week = _tmp_total*7;

        //     for(var i = 1; i < n; i++){
        //         var days_pow = i + 1;
        //         // console.log('days_pow:'+days_pow);
        //         // console.log(_tmp_total+' * Math.pow((1 + '+_tmp_budget_addition+'), '+days_pow+') * 7');

        //         //console.log('('+_tmp_total +'+ ('+days_pow+' - 1) * '+_tmp_budget_addition+') * 7');
        //         _tmp_interval_week = (parseInt(_tmp_total) + (parseInt(days_pow) - 1) * parseInt(_tmp_budget_addition)) * 7;

        //         // console.log(interval_week +'='+ interval_week +'+'+ _tmp_interval_week);
        //         interval_week = interval_week + _tmp_interval_week;
        //     }

        //     // console.log(_tmp_total + ' * Math.pow((1 + '+_tmp_budget_addition+'), '+n+') * ('+_tmp_days+' - 7 * '+n+')');

        //     //console.log('('+_tmp_total +'+'+ n +'*'+ _tmp_budget_addition+') * ('+_tmp_days +' - 7 * '+ n+')');
        //     var finish_week = (parseInt(_tmp_total) + parseInt(n) * parseInt(_tmp_budget_addition)) * (parseInt(_tmp_days) - 7 * parseInt(n));

        //     if(_tmp_days > 0 && _tmp_total > 0){
        //         // console.log('Math.round('+first_week +'+'+ interval_week +'+'+ finish_week+')');
        //         html = Math.round(parseInt(first_week) + parseInt(interval_week) + parseInt(finish_week));
        //     }

        //     _test_total = html;

        //     this.Budget_KW_result = html;

        //     //計算最低預算比率
        //     let _ratio = ((Math.ceil(((parseInt(_test_total) / (parseInt(_tmp_total) * parseInt(_tmp_days))))*100)/100 - 1)*100).toFixed(0);

        //     this.updateMinAddition = _ratio;

        //     if(parseInt(budgetAddition) < parseInt(_ratio)){
        //       // console.log('有結束日期之下，不允許小於:'+_ratio);
        //       this.goalsData.form_addition = _ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ _ratio);
        //     }
        //   } else {
        //     // console.log('沒結束日期也沒日期間距');
        //     var _tmp_keyword_split_budget = budgetKW;
        //     var video_min_price = this.currencyData.currency_video_min_price;
        //     var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //     if(_tmp_keyword_split_budget == 0){
        //         single_ratio = 0;
        //     }

        //     this.updateMinAddition = single_ratio;

        //     if(parseInt(budgetAddition) < parseInt(single_ratio)){
        //       // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //       this.goalsData.form_addition = single_ratio;
        //     } else {
        //       // console.log(budgetAddition +" > "+ single_ratio);
        //     }
        //   }

        // } else {
        //   //沒結束日期
        //   // console.log('沒結束日期');
        //   var _tmp_keyword_split_budget = budgetKW;
        //   var video_min_price = this.currencyData.currency_video_min_price;
        //   var single_ratio = Math.ceil((video_min_price/(parseInt(_tmp_keyword_split_budget)))*100);
        //   if(_tmp_keyword_split_budget == 0){
        //       single_ratio = 0;
        //   }

        //   this.updateMinAddition = single_ratio;

        //   if(budgetAddition < single_ratio){
        //     // console.log('沒結束日期之下，不允許小於:'+single_ratio);
        //     this.goalsData.form_addition = single_ratio;
        //   } else {
        //     // console.log(budgetAddition +" > "+ single_ratio);
        //   }
        // }

        // console.log('update this.updateMinAddition:'+this.updateMinAddition);

        // return 'string form test_call';
      },
      dateGapTime(value){
        // console.log('dateGapTime:'+value);
        // console.log('b this.returnGapTime:'+this.returnGapTime);
        this.returnGapTime = value;

        if(value > 0){
          this.minAddition(this.goalsData.form_addition, value, this.budgetKW, this.returnUseEndDate);
        }

        // console.log('a this.returnGapTime:'+this.returnGapTime);
      },
      dateEndTime(value){
        // console.log('dateEndTime:'+value);
        // console.log('b this.returnEndTime:'+this.returnEndTime);
        this.returnEndTime = value;

        let startTime = this.dateData.start_date;
        let diffType = 'day';
        let gapTime = 0;

        if(startTime != '' && startTime != '0000-00-00' && startTime != null && value != '' && value != '0000-00-00' && value != null){
          diffType = diffType.toLowerCase();
          var sTime =new Date(startTime); //開始時間
          var eTime =new Date(value); //結束時間
          //作為除數的數字
          var timeType = 1;
          switch (diffType) {
              case"second":
                  timeType =1000;
              break;
              case"minute":
                  timeType =1000*60;
              break;
              case"hour":
                  timeType =1000*3600;
              break;
              case"day":
                  timeType =1000*3600*24;
              break;
              default:
              break;
          }
          gapTime = parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
        }

        this.returnGapTime = gapTime;

        this.minAddition(this.goalsData.form_addition, gapTime, this.budgetKW, this.returnUseEndDate);

        // console.log('a this.returnEndTime:'+this.returnEndTime);
      },
      dateUseEndDate(value){
        // console.log('dateUseEndDate:'+value);
        // console.log('b this.returnUseEndDate:'+this.returnUseEndDate);
        this.returnUseEndDate = value

        this.minAddition(this.goalsData.form_addition, this.returnGapTime, this.budgetKW, value);

        // console.log('a this.returnUseEndDate:'+this.returnUseEndDate);
      },
      goalsObjective(value){
        console.log('event goalsObjective')
        console.log(value);
        console.log('this.goalsData');
        console.log(this.goalsData);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = yearForm + monthForm + dateForm + timeForm;

        this.getGoalsObjective = value

        if(value == 'CONVERSIONS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'LINK_CLICKS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'POST_ENGAGEMENT'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'VIDEO_VIEWS'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.adMaterialData.creative_array = []
        }
        if(value == 'LEAD_GENERATION'){
          this.showMaterial = false;
          this.showAdvertisingMaterial = true;
          this.showForm = true;
          this.showMsg = false;

          this.showStageMaterial = 'false_'+get_value;
          this.showStageAdvertisingMaterial = 'true_'+get_value;
          this.showStageForm = 'true_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          // if(this.adMaterialData.creative_array == null){
          //   this.adMaterialData.creative_array = [
          //     {
          //       title: "xxxx",
          //       isEdit: false,
          //       type: 1,
          //       materials:[],
          //       materialSingle: [
          //         {
          //           src: null,
          //           title: null,
          //           size: null
          //         }
          //       ],
          //       callActive: 'SIGN_UP'
          //     }
          //   ]
          // }
        }
        if(value == 'MESSAGES'){
          this.showMaterial = true;
          // this.showAdvertisingMaterial = false;
          this.showForm = false;
          // this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'true_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'true_'+get_value;

          // if(this.adMaterialData.creative_array == null){
          //   this.adMaterialData.creative_array = [
          //     {
          //       title: "xxxx",
          //       isEdit: false,
          //       type: 1,
          //       materials:[],
          //       materialSingle: [
          //         {
          //           src: null,
          //           title: null,
          //           size: null
          //         }
          //       ],
          //       callActive: 'SIGN_UP'
          //     }
          //   ]
          // }
        }

        if(value == 'PRODUCT_CATALOG_SALES'){
          this.showMaterial = true;
          this.showAdvertisingMaterial = false;
          this.showForm = false;
          this.showMsg = false;

          this.showStageMaterial = 'true_'+get_value;
          this.showStageAdvertisingMaterial = 'false_'+get_value;
          this.showStageForm = 'false_'+get_value;
          this.showStageMsg = 'false_'+get_value;

          this.postData.select_article = [];
          this.postData.select_creatives = [];

          console.log('is PRODUCT_CATALOG_SALES');
        } else {
          this.postData.select_creatives_adset_ads = [];

          console.log('not PRODUCT_CATALOG_SALES');
        }

        console.log(this.postData);

        this.adMaterialDataNew = this.tmpAdMaterialDataNew

        // console.log('this.showMaterial:'+this.showMaterial);
        // console.log('this.showAdvertisingMaterial:'+this.showAdvertisingMaterial);
        // console.log('this.showForm:'+this.showForm);
        // console.log('this.showMsg:'+this.showMsg);

        // console.log('this.adMaterialData');
        // console.log(this.adMaterialData);
      },
      objectiveOption(value){
        if(value != '' && value != null && typeof value != 'undefined'){
          let objectiveOptionValue = value.split("|");

          // console.log('objectiveOption');
          // console.log(objectiveOptionValue);
          // console.log(this.formPixelId);

          this.formPixelId = objectiveOptionValue[0]

          // console.log(this.formPixelId);
        }
      },
      keywordUrl(value){
        // console.log('keywordUrl')
        // console.log(value);

        this.productUrl = value
      },
      getHere(target, refName, groupType){
        console.log('getHere', target, refName, groupType, this.menu);

        this.changeYoutubeType();

        this.target = target

        // if(this.menu[1].show == false){
        //   if (target > 1) {
        //     target -= 1
        //   }
          this.process = parseInt(50) * (parseInt(target) - parseInt(1))
        // } else {
        //   this.process = parseInt(25) * (parseInt(target) - parseInt(1))
        // }

        // this.process = parseInt(50)

        this.$nextTick(() => {
          if(typeof groupType !== 'undefined'){
            let childComponent = this.$refs.childCampaignName;
            if(groupType === 'childBudgetSchedule'){
              childComponent = this.$refs.childBudgetSchedule;
            }
            if(groupType === 'childBenefitAndContribution'){
              childComponent = this.$refs.childBenefitAndContribution;
            }
            if(groupType === 'childOptimizationMethod'){
              childComponent = this.$refs.childOptimizationMethod;
            }
            if(groupType === 'childKeywordMix'){
              childComponent = this.$refs.childKeywordMix;
            }
            if(groupType === 'childAdvertisingMix'){
              childComponent = this.$refs.childAdvertisingMix;
            }
            if(groupType === 'childRemarketingMix'){
              childComponent = this.$refs.childRemarketingMix;
            }
            if(groupType === 'childMarketingDate'){
              childComponent = this.$refs.childMarketingDate;
            }
            if(groupType === 'childGoalsAndBudget'){
              childComponent = this.$refs.childGoalsAndBudget;
            }
            if(groupType === 'childRegions'){
              childComponent = this.$refs.childRegions;
            }
            if(groupType === 'childRelationship'){
              childComponent = this.$refs.childRelationship;
            }
            if(groupType === 'childPositionDevice'){
              childComponent = this.$refs.childPositionDevice;
            }
            if(groupType === 'childIdentity'){
              childComponent = this.$refs.childIdentity;
            }
            if(groupType === 'childMaterial'){
              childComponent = this.$refs.childMaterial;
            }
            if(groupType === 'childCustomizeMaterial'){
              childComponent = this.$refs.childCustomizeMaterial;
            }
            console.log('childComponent', childComponent);
            if (childComponent && childComponent.$refs[refName]) {
              console.log('移動');
              childComponent.$refs[refName].scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }
        });

        document.getElementById('edit_content').scrollTop = 0;
      },
      eventPageId(value) {
        // console.log('methods eventPageId')
        // console.log(value);
        this.formPageId = value
      },
      eventFormId(value) {
        console.log('methods eventFormId')
        console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.formId = get_value
        } else {
          this.formId = []
        }
      },
      eventMessageId(value) {
        console.log('methods eventMessageId')
        console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
        if(value != '' && value != null && typeof value != 'undefined'){
          this.messageId = get_value
        } else {
          this.messageId = []
        }
      },
      adMaterialContent(value){
        // console.log('adMaterialContent')
        // console.log(value);

        if(typeof value.creative_array != 'undefined'){
          this.adMaterialDataNew = value
        } else {
          this.adMaterialDataNew.creative_array = value
        }
      },
      formChangeFormId(value){
        console.log('b this.changeFormId')
        console.log(this.changeFormId);

        console.log('value')
        console.log(value);

        // this.changeFormId = null

        // console.log('c this.changeFormId')
        // console.log(this.changeFormId);

        this.changeFormId = value

        console.log('a this.changeFormId')
        console.log(this.changeFormId);
      },
      formChangeMessageId(value){
        // console.log('formChangeMessageId')
        // console.log(value);

        this.changeMessageId = value
      },
      activeScroll(value){
        let tmpDataType = value.split('_');

        if(tmpDataType[0] == 1){
          this.showAdvertisingMaterial = true;
          this.showMsg = true;

          this.AdvertisingMaterialStatus = this.showMsg;

          // this.$refs.scrollcontent.scrollTo({
          //   top: 1505,
          //   behavior: 'smooth'
          // });
        }
      },
      useASC(value){
        console.log('useASC');
        console.log(value);

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        todayForm = yearForm + monthForm + dateForm + timeForm;

        if(value == true){
          this.haveASC = 'true_'+todayForm;
        } else {
          this.haveASC = 'false_'+todayForm;
        }
      },
      processData(data) {
        let return_type = data.some(Array.isArray) ? 1 : 2;

        const flattenArray = (arr) => {
          return arr.reduce((acc, val) =>
            Array.isArray(val) ? acc.concat(flattenArray(val)) : acc.concat(val)
          , []);
        };

        let flattened_data = flattenArray(data);

        return {
          return_type: return_type,
          data: flattened_data
        };
      },
      setHideCustom(data){
        let value = data.split('|||');
        console.log('setHideCustom');
        console.log(this.otherCustomCampaignId);

        Swal.fire({
          title: '刪除其他自定義',
          html: '您要刪除「'+value[0]+'」其他自定義規則嗎？',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          width: 'auto', // 可選：根據內容自動調整寬度
          padding: '1em',
          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
          cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
        }).then((result) => {
          if (result.isConfirmed) {
            console.log(value);

            this.showCampaignData = false;

            axios
              .post('https://test.autoturn.net/inside/api/data/campaign_subset_status_update.php', Qs.stringify({
                s_code: this.$route.params.id,
                campaign_id: value[1],
              }))
              .then((response) => {
                // console.log(response.data);
                this.showCampaignData = true;

                if(response.data.status == 'success'){
                  Swal.fire({
                    icon: response.data.status,
                    title: '刪除其他自定義',
                    text: response.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['EventAdd']['methods']['release']['have_campaign_id']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    this.showCampaignData = false;
                    /* Read more about isConfirmed, isDenied below */
                    // if (result.isConfirmed) {
                    //   // Swal.fire('Saved!', '', 'success')
                    //   this.allPageLoading = true
                    //   window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                    // } else if (result.isDenied) {
                    //   // Swal.fire('Changes are not saved', '', 'info')
                    //   this.allPageLoading = true
                    //   window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                    // }

                    // if (result.dismiss === Swal.DismissReason.timer) {
                    //   this.allPageLoading = true
                    //   window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                    // }

                    axios
                      .post('https://test.autoturn.net/inside/api/target/campaign/campaign.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        adaccount_id: this.$route.params.adaccount_id,
                        campaign_id: this.$route.params.campaign_id
                      }))
                      .then((response) => {
                        if(response.data.status == 'success'){
                          let otherSubsetDataLength = response.data.return_data.other_subset_data.length;
                          for(let i = 0; i < otherSubsetDataLength; i++){
                            if(response.data.return_data.other_subset_data[i].main_campaign_id == this.otherCustomCampaignId){
                              response.data.return_data.other_subset_data[i].selected = true;
                            }
                          }
                          this.otherCustomTitle = response.data.return_data.other_subset_data;

                          if(otherSubsetDataLength == 0){
                            this.showOtherTargetCR = false;
                            this.methodData.Other_Target_CR = false;
                          }
                        }

                        this.showCampaignData = true;
                      });
                  })
                }
              });
          }
        });
      },
      hasValue(value, ignoreZero = false) {
        if (value === null || value === undefined || value === "") {
          return false;
        }

        if (ignoreZero && value === 0) {
          return false;
        }

        return true;
      },
      validateBeneficiary() {
        if (this.hasValue(this.benefitsAndInvestmentData.selectedBeneficiary, true)) {
          return true;
        }

        return (
          this.hasValue(this.benefitsAndInvestmentData.beneficiary_id, true) &&
          this.hasValue(this.benefitsAndInvestmentData.beneficiary_name, true)
        );
      },
      validatePayer() {
        if (this.hasValue(this.benefitsAndInvestmentData.selectedPayer, true)) {
          return true;
        }

        return (
          this.hasValue(this.benefitsAndInvestmentData.payer_id, true) &&
          this.hasValue(this.benefitsAndInvestmentData.payer_name, true)
        );
      },
      prev() {
        // console.log('now target:'+this.target);
        let isTrue = 1;

        this.changeYoutubeType();

        if(this.target == 2){
          // console.log('risk_level:'+this.goalsData.risk_level.code);
          // console.log('effect:'+this.goalsData.effect);
          // if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
          //   Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['prev']['empty_effect_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['prev']['empty_effect_swal_text'],
          //             "warning"
          //           )

          //   isTrue = 0;
          // }
        }

        if(isTrue == 1){
          // if(this.menu[1].show == false){
          this.process -= 50

          if (this.target > 1) {
            this.target -= 1

            // if(this.target == 2){
            //   this.target -= 1
            // }
          }
          // } else {
          //   this.process -= 25
          //   if (this.target > 1) {
          //     this.target -= 1
          //   }
          // }
          // console.log('prev target:'+this.target);

          document.getElementById('edit_content').scrollTop = 0;
        }
      },
      next() {
        // console.log('now target:'+this.target);
        let isTrue = 1;

        console.log('next');

        this.changeYoutubeType();

        if(this.target == 2){
          // console.log('risk_level:'+this.goalsData.risk_level.code);
          // console.log('effect:'+this.goalsData.effect);
          // if((this.goalsData.risk_level.code == 'auto' || this.goalsData.risk_level.code == 'low') && (this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null)){
          //   Swal.fire(
          //             this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_effect_swal_title'],
          //             this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_effect_swal_text'],
          //             "warning"
          //           )

          //   isTrue = 0;
          // }

          let event_text = this.showLang[this.selectLang]['views']['Event']['methods']['next']['product_datalog_sales_default_event_text'];
          if(this.goalsData.campaign_objective == 'PRODUCT_CATALOG_SALES'){
            event_text = this.showLang[this.selectLang]['views']['Event']['methods']['next']['is_product_datalog_sales_default_event_text'];
          }

          if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
            Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_product_catalog_sales_swal_title'],
                      event_text,
                      "warning"
                    )

            isTrue = 0;
          }

          if(this.goalsData.campaign_objective == 'PRODUCT_CATALOG_SALES'){
            if(this.goalsData.product_set_id == '' || this.goalsData.product_set_id == null || typeof this.goalsData.product_set_id == 'undefined'){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_product_catalog_sales_swal_title'],
                        this.showLang[this.selectLang]['views']['Event']['methods']['next']['is_product_datalog_sales_set_id_event_text'],
                        "warning"
                      )

              isTrue = 0;
            }

            if(this.goalsData.product_catalog_id == '' || this.goalsData.product_catalog_id == null || typeof this.goalsData.product_catalog_id == 'undefined'){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['Event']['methods']['next']['empty_product_catalog_sales_swal_title'],
                        this.showLang[this.selectLang]['views']['Event']['methods']['next']['is_product_datalog_sales_catalog_id_event_text'],
                        "warning"
                      )

              isTrue = 0;
            }
          }
        }

        if(isTrue == 1){
          console.log('next target:'+this.target);
          if(this.target >= 2){
            console.log('儲存並發佈');
            // this.release();
            this.form_update();
          }

          // if(this.menu[1].show == false){

          console.log('now target:'+this.target);
          if (this.target <= 1) {
            this.process += 50
            this.target += 1
            this.menu[this.target-1].open = true
          }

          // } else {
          //   if(this.process < 75){
          //     this.process += 25
          //     // console.log('now target:'+this.target);
          //     if (this.target <= 4) {
          //       this.target += 1
          //       this.menu[this.target-1].open = true
          //     }
          //     // console.log('next target:'+this.target);
          //   }
          //   // console.log('next target:'+this.target);
          // }
          // console.log('next target:'+this.target);

          document.getElementById('edit_content').scrollTop = 0;
        }
      },
      async form_update() {
        let member_hash = this.$route.params.id
        let adaccount_id = this.$route.params.adaccount_id

        this.changeYoutubeType();

        if(this.nextLoading == false){
          this.nextLoading = true;
          this.showCampaignData = false;

          console.log('非自定義儲存');

          axios
              .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
                s_code: member_hash,
                route_type: this.$route.params.type,
                active: 'member',
              }))
              .then((caResponse) => {

                if(caResponse.data.status == 'error'){
                  this.nextLoading = false;
                  this.showCampaignData = true;

                  if(caResponse.data.type == 2){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                      }
                    })
                  } else if(caResponse.data.type == 3){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/f/"+member_hash;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/f/"+member_hash;
                      }
                    })
                  } else {
                    Swal.fire(
                              this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['error']['swal_title'],
                              caResponse.data.info,
                              caResponse.data.status
                            )
                  }
                }

                if(caResponse.data.status == 'warning'){
                  Swal.fire({
                    icon: 'warning',
                    title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    if(this.methodData.Budget_LA != ''){
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                      _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                      // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));
                    }

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    if(this.methodData.Budget_RT != ''){
                      // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                      _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                      // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                      marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));
                    }

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_id: this.campaign_id,
                      campaign_name: this.campaign_name,
                      adaccount_id: this.adaccount_id,
                      optimizedData: this.optimizedData,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      useDefaultLayout: this.useDefaultLayout,
                      dynBudgetData: this.dynBudgetData,
                      methodData: this.methodData,
                      benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                      dateData: this.dateData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      // exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew
                    }

                    // console.log('a this.adMaterialDataNew');
                    // console.log(this.adMaterialDataNew);

                    if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                      // console.log('#1');
                      let materialType = 0;
                      let selectArticleLength = 0;
                      if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                        selectArticleLength = this.postData.select_article.length;
                      }

                      let selectCreativesMessageLength = 0;
                      if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                        selectCreativesMessageLength = this.postData.select_creatives_message.length;
                      }

                      let selectCreativesAdsetAdsMessageLength = 0;
                      if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                        selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                      }

                      let creativeArrayLength = 0;
                      if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                        creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                      }

                      if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        materialType = 1;
                      } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                        materialType = 2;
                      }

                      console.log('#1 materialType:'+materialType);

                      if(materialType == 0){
                        console.log('#5');
                        axios
                          .post('https://test.autoturn.net/inside/api/target/data/campaign_update_v01.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: 'finish',
                            target: 'edit_update_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              let taskId = response.data.id;

                              if(taskId != null && taskId != '' && typeof taskId != 'undefined'){
                                var status = 1;
                                this.releaseType = true
                                this.style = 'z-index:100;';
                                console.log('releaseType');
                                var bar5 = new ldBar("#myItem5");
                                bar5.set(this.releasePercent);
                                setInterval( () => {
                                  if(status == 1){
                                    console.log('status');
                                    console.log(status);
                                    axios
                                      .post('https://test.autoturn.net/inside/api/target/campaign/campaign_task.php', Qs.stringify({
                                        s_code: this.$route.params.id,
                                        id: taskId,
                                      }))
                                      .then((taskResponse) => {
                                        // console.log('post_task');
                                        // console.log(taskResponse.data);
                                        if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                          status = 0;
                                          Swal.fire({
                                            icon: 'error',
                                            title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_title'],
                                            text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['confirm_button'],
                                            // timer: 5000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            this.releaseType = false
                                            this.style = 'z-index:-1;';
                                            this.releasePercent = 5;
                                            /* Read more about isConfirmed, isDenied below */
                                            // if (result.isConfirmed) {
                                            //   // Swal.fire('Saved!', '', 'success')
                                            //   this.showCampaignData = true
                                            //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                            // } else if (result.isDenied) {
                                            //   // Swal.fire('Changes are not saved', '', 'info')
                                            //   this.showCampaignData = true
                                            //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                            // }

                                            // if (result.dismiss === Swal.DismissReason.timer) {
                                            //   this.showCampaignData = true
                                            //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                            // }
                                          })
                                        } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                          status = 0;

                                          Swal.fire({
                                            icon: 'success',
                                            title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_swal_title'],
                                            text: response.data.info,
                                            /*text: '修改完成，5秒後將為您導回列表頁。',*/
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_confirm_button'],
                                            // confirmButtonText: '確定',
                                            timer: 5000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.showCampaignData = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.showCampaignData = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.showCampaignData = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            }
                                          })
                                        } else {
                                          this.releasePercent = taskResponse.data.return_data.pct

                                          bar5.set(this.releasePercent);

                                          if(taskResponse.data.return_data.pct == 100){
                                            this.releaseType = false
                                            this.style = 'z-index:-1;';
                                            this.releasePercent = 5;
                                            status = 0;
                                          }
                                        }

                                        // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                        // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                        // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                        // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                      });
                                  }
                                }, 3000);
                              } else {
                                Swal.fire({
                                  icon: 'success',
                                  title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['update_swal_title'],
                                  text: response.data.info,
                                  showDenyButton: false,
                                  showCancelButton: false,
                                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['update_confirm_button'],
                                  // denyButtonText: `Don't save`,
                                }).then((result) => {
                                  /* Read more about isConfirmed, isDenied below */
                                  if (result.isConfirmed) {
                                    // Swal.fire('Saved!', '', 'success')

                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                  } else if (result.isDenied) {
                                    // Swal.fire('Changes are not saved', '', 'info')
                                  }
                                })
                              }

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                            } else {
                              let text = this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
                                text,
                                'error'
                              )
                            }

                            this.nextLoading = false;
                            this.showCampaignData = true;
                          });
                      } else {
                        console.log('#31');
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_text'],
                                    "error"
                                  )

                        this.nextLoading = false;
                        this.showCampaignData = true;
                      }
                    } else {
                      console.log('#6');
                      axios
                        .post('https://test.autoturn.net/inside/api/target/data/campaign_update_v01.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: 'finish',
                          target: 'edit_update_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            let taskId = response.data.id;

                            if(taskId != null && taskId != '' && typeof taskId != 'undefined'){
                              var status = 1;
                              this.releaseType = true
                              this.style = 'z-index:100;';
                              console.log('releaseType');
                              var bar5 = new ldBar("#myItem5");
                              bar5.set(this.releasePercent);
                              setInterval( () => {
                                if(status == 1){
                                  console.log('status');
                                  console.log(status);
                                  axios
                                    .post('https://test.autoturn.net/inside/api/target/campaign/campaign_task.php', Qs.stringify({
                                      s_code: this.$route.params.id,
                                      id: taskId,
                                    }))
                                    .then((taskResponse) => {
                                      // console.log('post_task');
                                      // console.log(taskResponse.data);
                                      if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                        status = 0;
                                        Swal.fire({
                                          icon: 'error',
                                          title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_title'],
                                          text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['confirm_button'],
                                          // timer: 5000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          /* Read more about isConfirmed, isDenied below */
                                          // if (result.isConfirmed) {
                                          //   // Swal.fire('Saved!', '', 'success')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // } else if (result.isDenied) {
                                          //   // Swal.fire('Changes are not saved', '', 'info')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }

                                          // if (result.dismiss === Swal.DismissReason.timer) {
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }
                                        })
                                      } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                        status = 0;
                                        Swal.fire({
                                          icon: 'success',
                                          title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_swal_title'],
                                          text: response.data.info,
                                          /*text: '修改完成，5秒後將為您導回列表頁。',*/
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_confirm_button'],
                                          // confirmButtonText: '確定',
                                          timer: 5000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          if (result.isConfirmed) {
                                            // Swal.fire('Saved!', '', 'success')
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          } else if (result.isDenied) {
                                            // Swal.fire('Changes are not saved', '', 'info')
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          }

                                          if (result.dismiss === Swal.DismissReason.timer) {
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          }
                                        })
                                      } else {
                                        this.releasePercent = taskResponse.data.return_data.pct

                                        bar5.set(this.releasePercent);

                                        if(taskResponse.data.return_data.pct == 100){
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          status = 0;
                                        }
                                      }

                                      // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                      // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                      // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                      // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                    });
                                }
                              }, 3000);
                            } else {
                              Swal.fire({
                                icon: 'success',
                                title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['campaign_update']['success']['swal_title'],
                                text: response.data.info,
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['campaign_update']['success']['confirm_button'],
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')

                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                }
                              })
                            }

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                          } else {
                            let text = this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['campaign_update']['not_success']['default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['warning']['campaign_update']['not_success']['swal_title'],
                              text,
                              'error'
                            )
                          }

                          this.nextLoading = false;
                          this.showCampaignData = true;
                        });
                    }
                  });
                }

                if(caResponse.data.status == 'success'){
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  if(this.methodData.Budget_LA != ''){
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));
                  }

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  if(this.methodData.Budget_RT != ''){
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));
                  }

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  console.log('20220930');

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  // console.log(_tmp_exAudiencesData);

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_id: this.campaign_id,
                    campaign_name: this.campaign_name,
                    adaccount_id: this.adaccount_id,
                    optimizedData: this.optimizedData,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    useDefaultLayout: this.useDefaultLayout,
                    dynBudgetData: this.dynBudgetData,
                    methodData: this.methodData,
                    benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                    dateData: this.dateData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    // exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  // console.log('b this.adMaterialDataNew');
                  // console.log(this.adMaterialDataNew);

                  if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                    // console.log('#1');
                    let materialType = 0;
                    let selectArticleLength = 0;
                    if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                      selectArticleLength = this.postData.select_article.length;
                    }

                    let selectCreativesMessageLength = 0;
                    if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                      selectCreativesMessageLength = this.postData.select_creatives_message.length;
                    }

                    let selectCreativesAdsetAdsMessageLength = 0;
                    if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                      selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                    }

                    let creativeArrayLength = 0;
                    if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                      creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                    }

                    if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      materialType = 1;
                    } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                      materialType = 2;
                    }

                    console.log('#2 materialType:'+materialType);

                    if(materialType == 0){
                      console.log('#7');
                      axios
                        .post('https://test.autoturn.net/inside/api/target/data/campaign_browse_update.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: 'finish',
                          target: 'edit_update_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form
                            let taskId = response.data.id;

                            if(taskId != null && taskId != '' && typeof taskId != 'undefined'){
                              var status = 1;
                              this.releaseType = true
                              this.style = 'z-index:100;';
                              console.log('releaseType');
                              var bar5 = new ldBar("#myItem5");
                              bar5.set(this.releasePercent);
                              setInterval( () => {
                                if(status == 1){
                                  console.log('status');
                                  console.log(status);
                                  axios
                                    .post('https://test.autoturn.net/inside/api/target/campaign/campaign_task.php', Qs.stringify({
                                      s_code: this.$route.params.id,
                                      id: taskId,
                                    }))
                                    .then((taskResponse) => {
                                      // console.log('post_task');
                                      // console.log(taskResponse.data);
                                      if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                        status = 0;
                                        Swal.fire({
                                          icon: 'error',
                                          title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_title'],
                                          text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['confirm_button'],
                                          // timer: 5000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          /* Read more about isConfirmed, isDenied below */
                                          // if (result.isConfirmed) {
                                          //   // Swal.fire('Saved!', '', 'success')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // } else if (result.isDenied) {
                                          //   // Swal.fire('Changes are not saved', '', 'info')
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }

                                          // if (result.dismiss === Swal.DismissReason.timer) {
                                          //   this.showCampaignData = true
                                          //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                          // }
                                        })
                                      } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                        status = 0;
                                        Swal.fire({
                                          icon: 'success',
                                          title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_swal_title'],
                                          text: response.data.info,
                                          /*text: '修改完成，5秒後將為您導回列表頁。',*/
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_confirm_button'],
                                          // confirmButtonText: '確定',
                                          timer: 5000
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          if (result.isConfirmed) {
                                            // Swal.fire('Saved!', '', 'success')
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          } else if (result.isDenied) {
                                            // Swal.fire('Changes are not saved', '', 'info')
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          }

                                          if (result.dismiss === Swal.DismissReason.timer) {
                                            this.showCampaignData = true
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          }
                                        })
                                      } else {
                                        this.releasePercent = taskResponse.data.return_data.pct

                                        bar5.set(this.releasePercent);

                                        if(taskResponse.data.return_data.pct == 100){
                                          this.releaseType = false
                                          this.style = 'z-index:-1;';
                                          this.releasePercent = 5;
                                          status = 0;
                                        }
                                      }

                                      // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                      // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                      // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                      // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                    });
                                }
                              }, 3000);
                            } else {
                              Swal.fire({
                                icon: 'success',
                                title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_swal_title'],
                                text: response.data.info,
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_confirm_button'],
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')

                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                }
                              })
                            }

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                          } else {
                            let text = this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_swal_title'],
                              text,
                              'error'
                            )
                          }

                          this.nextLoading = false;
                          this.showCampaignData = true;
                        });
                    } else {
                      console.log('#32');
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_text'],
                                  "error"
                                )

                      this.nextLoading = false;
                      this.showCampaignData = true;
                    }
                  } else {
                    console.log('#8');
                    axios
                      .post('https://test.autoturn.net/inside/api/target/data/campaign_browse_update.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                        type: 'finish',
                        target: 'edit_update_'+this.target,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          let taskId = response.data.id;

                          if(taskId != null && taskId != '' && typeof taskId != 'undefined'){
                            var status = 1;
                            this.releaseType = true
                            this.style = 'z-index:100;';
                            console.log('releaseType');
                            var bar5 = new ldBar("#myItem5");
                            bar5.set(this.releasePercent);
                            setInterval( () => {
                              if(status == 1){
                                console.log('status');
                                console.log(status);
                                axios
                                  .post('https://test.autoturn.net/inside/api/target/campaign/campaign_task.php', Qs.stringify({
                                    s_code: this.$route.params.id,
                                    id: taskId,
                                  }))
                                  .then((taskResponse) => {
                                    // console.log('post_task');
                                    // console.log(taskResponse.data);
                                    if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'FAILURE'){
                                      status = 0;
                                      Swal.fire({
                                        icon: 'error',
                                        title: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_title'],
                                        text: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['swal_text']+taskResponse.data.return_data.current,
                                        showDenyButton: false,
                                        showCancelButton: false,
                                        confirmButtonText: this.showLang[this.selectLang]['views']['EventBrowse']['methods']['form_update']['campaign_member_status']['warning']['campaign_browse_update']['material']['info_state_failure']['confirm_button'],
                                        // timer: 5000
                                        // denyButtonText: `Don't save`,
                                      }).then((result) => {
                                        this.releaseType = false
                                        this.style = 'z-index:-1;';
                                        this.releasePercent = 5;
                                        /* Read more about isConfirmed, isDenied below */
                                        // if (result.isConfirmed) {
                                        //   // Swal.fire('Saved!', '', 'success')
                                        //   this.showCampaignData = true
                                        //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                        // } else if (result.isDenied) {
                                        //   // Swal.fire('Changes are not saved', '', 'info')
                                        //   this.showCampaignData = true
                                        //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                        // }

                                        // if (result.dismiss === Swal.DismissReason.timer) {
                                        //   this.showCampaignData = true
                                        //   window.location.href = "https://dev-private.autoturn.net/event-browse/f/"+member_hash+"/"+adaccount_id+"/"+campaign_id;
                                        // }
                                      })
                                    } else if(taskResponse.data.return_data.state == 'SUCCESS' && taskResponse.data.return_data.info_state == 'SUCCESS'){
                                      status = 0;
                                      Swal.fire({
                                        icon: 'success',
                                        title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_swal_title'],
                                        text: response.data.info,
                                        /*text: '修改完成，5秒後將為您導回列表頁。',*/
                                        showDenyButton: false,
                                        showCancelButton: false,
                                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['lead_messages']['update_confirm_button'],
                                        // confirmButtonText: '確定',
                                        timer: 5000
                                        // denyButtonText: `Don't save`,
                                      }).then((result) => {
                                        /* Read more about isConfirmed, isDenied below */
                                        if (result.isConfirmed) {
                                          // Swal.fire('Saved!', '', 'success')
                                          this.showCampaignData = true
                                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                        } else if (result.isDenied) {
                                          // Swal.fire('Changes are not saved', '', 'info')
                                          this.showCampaignData = true
                                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                        }

                                        if (result.dismiss === Swal.DismissReason.timer) {
                                          this.showCampaignData = true
                                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                        }
                                      })
                                    } else {
                                      this.releasePercent = taskResponse.data.return_data.pct

                                      bar5.set(this.releasePercent);

                                      if(taskResponse.data.return_data.pct == 100){
                                        this.releaseType = false
                                        this.style = 'z-index:-1;';
                                        this.releasePercent = 5;
                                        status = 0;
                                      }
                                    }

                                    // console.log('taskResponse.data.return_data.state:'+taskResponse.data.return_data.state);
                                    // console.log('taskResponse.data.return_data.current:'+taskResponse.data.return_data.current);
                                    // console.log('taskResponse.data.return_data.pct:'+taskResponse.data.return_data.pct);
                                    // console.log('taskResponse.data.return_data.info_state:'+taskResponse.data.return_data.info_state);
                                  });
                              }
                            }, 3000);
                          } else {
                            Swal.fire({
                              icon: 'success',
                              title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['campaign_update']['success']['swal_title'],
                              text: response.data.info,
                              showDenyButton: false,
                              showCancelButton: false,
                              confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['campaign_update']['success']['confirm_button'],
                              // denyButtonText: `Don't save`,
                            }).then((result) => {
                              /* Read more about isConfirmed, isDenied below */
                              if (result.isConfirmed) {
                                // Swal.fire('Saved!', '', 'success')

                                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+this.$route.params.id+"/"+this.$route.params.adaccount_id;
                              } else if (result.isDenied) {
                                // Swal.fire('Changes are not saved', '', 'info')
                              }
                            })
                          }

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                        } else {
                          let text = this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['campaign_update']['not_success']['default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['success']['campaign_update']['not_success']['swal_title'],
                            text,
                            'error'
                          )
                        }

                        this.nextLoading = false;
                        this.showCampaignData = true;
                      });
                  }
                }

                if(caResponse.data.status == 'login'){
                  this.nextLoading = false;
                  this.showCampaignData = true;

                  Swal.fire({
                    icon: 'error',
                    title: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['login']['swal_title'],
                    text: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['login']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['form_update']['axios']['campaign_member_status']['login']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      // this.allPageLoading = true
                      window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      // this.allPageLoading = true
                      window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                    }
                  })
                }
              });
        }
      },
      release(){
        let isTrue = 1;

        this.changeYoutubeType();

        if(this.methodData.Target_CR == true || this.methodData.Other_Target_CR == true || this.useDefaultLayout !== null){
          console.log('自定義發布');
          this.customize();
        } else {
          console.log('原發布');
          if(this.adaccount_id == null || this.adaccount_id == '' || typeof this.adaccount_id == 'undefined'){
            // console.log('#1');
            Swal.fire({
              icon: 'error',
              title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_adaccount_id_swal_title'],
              text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_adaccount_id_swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText:  this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_adaccount_id_swal_confirm_button']
            }).then((result) => {
              if (result.isConfirmed) {
                this.allPageLoading = true
                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+this.$route.params.id;
              } else if (result.isDenied) {
                this.allPageLoading = true
                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+this.$route.params.id;
              }
            })

            isTrue = 0;
          }

          console.log('this.optimizedData', this.optimizedData);
          console.log('this.goalsData', this.goalsData);
          console.log('this.dateData', this.dateData);

          if(this.optimizedData.mode == 'target' && (this.goalsData.targetMonSales == 0 || this.goalsData.targetMonSales == '' || this.goalsData.targetMonSales == null || typeof this.goalsData.targetMonSales == 'undefined')){
            Swal.fire(
                      "行銷活動目標與預算-目標月銷量",
                      "請填寫目標月銷量。",
                      "error"
                    )
            isTrue = 0;
          }

          if(this.dateData.start_date != '' && this.dateData.start_date != '0000-00-00' && this.dateData.end_date != '' && this.dateData.end_date != '0000-00-00'){
            // console.log('#5');
            let startTime = this.dateData.start_date;
            let endTime = this.dateData.end_date;

            var sTime = new Date(startTime); //開始時間
            var eTime = new Date(endTime); //結束時間

            if(sTime > eTime){
              Swal.fire(
                        this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_start_date_swal_title'],
                        this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_start_date_swal_text'],
                        "error"
                      )
              isTrue = 0;
            }
          }

          // console.log(this.dateData.end_date+':'+this.dateData.use_end_date);

          if(this.dateData.end_date == '0000-00-00' && (this.dateData.use_end_date == false || typeof this.dateData.use_end_date == 'undefined')){
            // console.log('#6');
            Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_end_date_swal_title'],
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_end_date_swal_text'],
                      "error"
                    )
            isTrue = 0;
          }

          if(this.optimizedData.mode == 'fix' && (this.dateData.targetMonSales == 0 || this.dateData.targetMonSales == '' || this.dateData.targetMonSales == null || typeof this.dateData.targetMonSales == 'undefined')){
            Swal.fire(
                      "預算走期",
                      "請填寫預算類型的投遞金額。",
                      "error"
                    )
            isTrue = 0;
          }

          if (this.benefitsAndInvestmentData.toTaiwan === true) {
            const isBusiness = this.benefitsAndInvestmentData.person_or_business.value === 2;

            if (isBusiness === true) {
              if (!this.hasValue(this.benefitsAndInvestmentData.benefits, true) && 
                  !this.hasValue(this.benefitsAndInvestmentData.investment, true)) {
                Swal.fire(
                          '受益與出資設定',
                          '請設定出資者、受益者。',
                          "error"
                        )
                isTrue = 0;
              }
            } else {
              if (!this.validateBeneficiary()) {
                Swal.fire(
                          '受益與出資設定',
                          '您的受益者資料並未設定完成（選擇已驗證，或手動輸入名稱、ID）。',
                          "error"
                        )
                isTrue = 0;
              }
              if (!this.validatePayer()) {
                Swal.fire(
                          '受益與出資設定',
                          '您的出資者資料並未設定完成（選擇已驗證，或手動輸入名稱、ID）。',
                          "error"
                        )
                isTrue = 0;
              }
            }
          }

          // console.log('this.goalsData');
          // console.log(this.goalsData);
          // console.log('objective_option:'+this.goalsData.objective_option);
          // console.log('conversion_domain:'+this.goalsData.conversion_domain);
          // console.log('risk_level:'+this.goalsData.risk_level.code);
          // console.log('excluded_audiences:'+this.exAudiencesData.excluded_audiences);
          if(this.goalsData.objective_option == '' || this.goalsData.objective_option == null || typeof this.goalsData.objective_option == 'undefined'){
            // console.log('#9');
            Swal.fire(
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_objective_option_swal_title'],
                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_objective_option_swal_text'],
                    "error"
                  )
            isTrue = 0;
          }

          if(this.goalsData.campaign_objective == 'CONVERSIONS' && (this.goalsData.conversion_domain == '' || this.goalsData.conversion_domain == null || typeof this.goalsData.conversion_domain == 'undefined')){
            // console.log('#10');
            Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_conversion_domain_swal_title'],
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_conversion_domain_swal_text'],
                      "error"
                    )
            isTrue = 0;
          }

          ////////////////////////////////////////

          if(this.goalsData.effect == '' || this.goalsData.effect == 0 || this.goalsData.effect == null){
            // console.log('#11');
            Swal.fire(
                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['not_effect_swal_title'],
                      "請填寫目標成本。",
                      "error"
                    )

            isTrue = 0;
          }

          ////////////////////////////////////////

          if(this.isClass == 'y'){
            Swal.fire(
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['class_check_release_permissions']['swal_title'],
              this.showLang[this.selectLang]['views']['Event']['methods']['release']['class_check_release_permissions']['swal_text'],
              'warning'
            )

            isTrue = 0;
          }

          console.log('isTrue');
          console.log(isTrue);

          if(isTrue == 1){
            // console.log('#13');
            let member_hash = this.$route.params.id
            let adaccount_id = this.$route.params.adaccount_id

            axios
              .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
                s_code: member_hash,
                route_type: this.$route.params.type,
                active: 'release',
              }))
              .then((caResponse) => {

                if(caResponse.data.status == 'error'){
                  // console.log('#14');
                  if(caResponse.data.type == 2){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                      }
                    })
                  } else if(caResponse.data.type == 3){
                    Swal.fire({
                      icon: caResponse.data.status,
                      title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['confirm_button']
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/f/"+member_hash;
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.allPageLoading = true
                        window.location.href = "https://dev-private.autoturn.net/f/"+member_hash;
                      }
                    })
                  } else {
                    Swal.fire(
                              this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['error']['swal_title'],
                              caResponse.data.info,
                              caResponse.data.status
                            )
                  }
                }

                if(caResponse.data.status == 'warning'){
                  // console.log('#15');
                  Swal.fire({
                    icon: 'warning',
                    title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['swal_title'],
                    text: caResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    var daily_keyword_split_budget = this.methodData.Budget_KW;
                    var daily_demo_budget = this.methodData.Budget_DM;
                    var budget_addition = this.goalsData.form_addition;

                    if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                        var d1 = new Date(this.dateData.start_date);
                        var d2 = new Date(this.dateData.end_date);
                        var days = parseInt((d2-d1)/86400000) + parseInt(1);
                    } else {
                        var days = 0;
                    }

                    var keyword_split_budget = 0;
                    if(this.methodData.Budget_KW != ''){
                        keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                    }

                    var demo_budget = 0;
                    if(this.methodData.Budget_DM != ''){
                        demo_budget = this.methodData.Budget_DM * days;
                    }

                    var _tmp_audience_budget = 0;
                    var audience_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                    _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                    // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                    var _tmp_marketing_again_budget = 0;
                    var marketing_again_budget = 0;
                    // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                    _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                    // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                    marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                    // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                    var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                    if(isNaN(html)){
                        html = '0';
                    }

                    this.total_budget = html;

                    let _tmp_goalsData = this.goalsData;
                    const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                    let _tmp_exAudiencesData = this.exAudiencesData;
                    const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                    // console.log(_tmp_exAudiencesData);

                    delete _view_goalsData['objective_list'];
                    delete _view_exAudiencesData['custom_excluded_audiences'];

                    let formData = {
                      campaign_id: this.campaign_id,
                      campaign_name: this.campaign_name,
                      adaccount_id: this.adaccount_id,
                      optimizedData: this.optimizedData,
                      Budget_KW_result: this.Budget_KW_result,
                      total_budget: this.total_budget,
                      useDefaultLayout: this.useDefaultLayout,
                      dynBudgetData: this.dynBudgetData,
                      methodData: this.methodData,
                      benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                      dateData: this.dateData,
                      goalsData: _view_goalsData,
                      regionsData: this.regionsData,
                      selectCountries: this.selectCountries,
                      selectLangs: this.selectLangs,
                      // exAudiencesData: _view_exAudiencesData,
                      pdData: this.pdData,
                      idData: this.idData,
                      postData: this.postData,
                      adMaterialData: this.adMaterialDataNew
                    }

                    let adaccount_id = this.adaccount_id

                    if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                      // console.log('#1');
                      let materialType = 0;
                      let selectArticleLength = 0;
                      if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                        selectArticleLength = this.postData.select_article.length;
                      }

                      let selectCreativesMessageLength = 0;
                      if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                        selectCreativesMessageLength = this.postData.select_creatives_message.length;
                      }

                      let selectCreativesAdsetAdsMessageLength = 0;
                      if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                        selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                      }

                      let creativeArrayLength = 0;
                      if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                        creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                      }

                      if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        materialType = 1;
                      } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                        materialType = 2;
                      }

                      console.log('#3 materialType:'+materialType);

                      if(materialType == 0){
                        // console.log('#2');
                        let message_sr_i = 0;
                        let form_sr_i = 0;
                        let message = 0;
                        let single_object_spec = 0;
                        let single_title = 0;
                        let materials_item = 0;
                        let materials_object_spec = 0;
                        let materials_title = 0;
                        let ad_name = 0;

                        for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                          if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                            ad_name = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].type == 2){
                            let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                            if(materials_length < 2){
                              materials_item = 1;
                            } else {
                              for(let j = 0; j < materials_length; j++){
                                if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                                  materials_object_spec = 1;
                                }

                                if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                                  materials_title = 1;
                                }
                              }
                            }
                          }

                          if(this.adMaterialDataNew.creative_array[i].type == 1){
                            if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                              single_object_spec = 1;
                            }

                            if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                              single_title = 1;
                            }
                          }

                          if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                            message = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                            form_sr_i = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                            message_sr_i = 1;
                          }
                        }

                        if(ad_name == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_ad_name_swal_text'],
                                      "error"
                                    )
                        } else if(single_object_spec == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_object_spec_swal_text'],
                                      "error"
                                    )
                        } else if(single_title == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_single_title_swal_text'],
                                      "error"
                                    )
                        } else if(materials_item == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_item_swal_text'],
                                      "error"
                                    )
                        } else if(materials_object_spec == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_object_spec_swal_text'],
                                      "error"
                                    )
                        } else if(materials_title == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_materials_title_swal_text'],
                                      "error"
                                    )
                        } else if(message == 1){
                          Swal.fire(
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                      this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_swal_text'],
                                      "error"
                                    )
                        } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                          Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_form_sr_i_swal_text'],
                                    "error"
                                  )
                        } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                          Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_message_sr_i_swal_text'],
                                    "error"
                                  )
                        } else {
                          console.log('#9');
                          axios
                            .post('https://test.autoturn.net/inside/api/target/data/campaign_update_v01.php', Qs.stringify({
                              s_code: this.$route.params.id,
                              form_data: formData,
                              type: 'release',
                              target: 'edit_release_'+this.target,
                            }))
                            .then((response) => {
                              // console.log(response.data);
                              if(response.data.status == 'success'){
                                // console.log('#16');
                                // this.immediateList = response.data.return_data
                                // this.formData = response.data.return_data.form

                                if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                  let name = this.campaign_name;
                                  let currency = this.currencyData.currency;
                                  let addition = this.goalsData.form_addition;
                                  let daily_budget = this.methodData.daily_budget;

                                  let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                  if(this.methodData.Target_AD == true){
                                    addition_text = '';
                                  }
                                  let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                  let campaignInfo = '';

                                  Swal.fire({
                                    // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                    title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_title'],
                                    html: campaignInfo+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['swal_text_c'],
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['yes_button'],
                                    cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['no_button'],
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      // console.log(this.$route.params.id);

                                      this.releaseType = true
                                      this.style = 'z-index:100;';
                                      this.releasePercent = 5;
                                      let status = 1;
                                      let num = 0;
                                      let member_hash = this.$route.params.id;
                                      var bar5 = new ldBar("#myItem5");
                                      bar5.set(this.releasePercent);

                                      axios
                                        .post('https://test.autoturn.net/inside/api/campaign_release.php', Qs.stringify({
                                          s_code: member_hash,
                                          campaign_id: this.campaign_id,
                                        }))
                                        .then((caResponse) => {
                                          // console.log('caResponse:'+caResponse.data.return_data);
                                          if(caResponse.data.status == 'success'){
                                            // console.log('#17');
                                            //進行進度條
                                            // console.log('發佈莞成，開始跑進度條');
                                            setInterval( () => {
                                              num++;
                                              if(num < 1200){
                                                // console.log('num:'+num);
                                                // console.log(this.releaseType);

                                                if(this.releaseType == true){
                                                  axios
                                                    .post('https://test.autoturn.net/inside/api/campaign_states.php', Qs.stringify({
                                                      s_code: member_hash,
                                                      adaccount_id: this.adaccount_id,
                                                      campaign_id: this.campaign_id,
                                                    }))
                                                    .then((csResponse) => {
                                                      // console.log('csResponse:'+csResponse.data.return_data);
                                                      //進行進度條
                                                      if(status == 1){
                                                        if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                          this.releaseType = false
                                                          this.style = 'z-index:-1;';
                                                          bar5.set(0);
                                                          status = 0;
                                                          Swal.fire({
                                                            icon: 'error',
                                                            title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                            text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                            showDenyButton: false,
                                                            showCancelButton: false,
                                                            confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                          }).then((result) => {

                                                          })
                                                        } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                          status = 0;

                                                          let postData = {adaccount_id: this.$route.params.adaccount_id};
                                                          let codeHash = ['de', 'di']

                                                          const data = new URLSearchParams();
                                                          data.append('s_code', this.$route.params.id);
                                                          data.append('post_data', JSON.stringify(postData));
                                                          data.append('code_hash', JSON.stringify(codeHash));
                                                          data.append('update_type', true);

                                                          // 發送請求
                                                          navigator.sendBeacon(
                                                            'https://test.autoturn.net/inside/api/update_cache.php',
                                                            data
                                                          );

                                                          axios
                                                            .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                              s_code: member_hash,
                                                              id: this.campaign_id,
                                                            }))
                                                            .then((response) => {
                                                              axios
                                                                .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
                                                                .then((csResponse) => {
                                                                  this.releaseType = false

                                                                  Swal.fire({
                                                                    icon: 'success',
                                                                    title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                                    text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                                    showDenyButton: false,
                                                                    showCancelButton: false,
                                                                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                                    // timer: 5000
                                                                    // denyButtonText: `Don't save`,
                                                                  }).then((result) => {
                                                                    /* Read more about isConfirmed, isDenied below */
                                                                    if (result.isConfirmed) {
                                                                      // Swal.fire('Saved!', '', 'success')
                                                                      this.allPageLoading = true
                                                                      window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                                    } else if (result.isDenied) {
                                                                      // Swal.fire('Changes are not saved', '', 'info')
                                                                      this.allPageLoading = true
                                                                      window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                                    }

                                                                    if (result.dismiss === Swal.DismissReason.timer) {
                                                                      this.allPageLoading = true
                                                                      window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                                    }
                                                                  })
                                                                });
                                                            });
                                                        } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                          this.releaseType = false
                                                          this.style = 'z-index:-1;';
                                                          bar5.set(0);
                                                          status = 0;
                                                          Swal.fire({
                                                            icon: 'error',
                                                            title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                            text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                            showDenyButton: false,
                                                            showCancelButton: false,
                                                            confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                          }).then((result) => {

                                                          })
                                                        } else {
                                                          this.releaseText = csResponse.data.return_data.info_text
                                                          this.releasePercent = csResponse.data.return_data.info_pct

                                                          bar5.set(this.releasePercent);
                                                          // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                          // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                          // console.log('this.releaseText:'+this.releaseText);
                                                          // console.log('this.releasePercent:'+this.releasePercent);

                                                          if(csResponse.data.return_data.info_pct == 100){
                                                            this.releaseType = false
                                                            this.style = 'z-index:-1;';
                                                            bar5.set(0);
                                                            status = 0;
                                                          }
                                                        }
                                                      }
                                                    });
                                                }
                                              } else {
                                                Swal.fire({
                                                  icon: 'warning',
                                                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                                  text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                                  showDenyButton: false,
                                                  showCancelButton: false,
                                                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                                  timer: 1000
                                                  // denyButtonText: `Don't save`,
                                                }).then((result) => {
                                                  /* Read more about isConfirmed, isDenied below */
                                                  if (result.isConfirmed) {
                                                    // Swal.fire('Saved!', '', 'success')
                                                    this.allPageLoading = true
                                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                  } else if (result.isDenied) {
                                                    // Swal.fire('Changes are not saved', '', 'info')
                                                    this.allPageLoading = true
                                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                  }

                                                  if (result.dismiss === Swal.DismissReason.timer) {
                                                    this.allPageLoading = true
                                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                  }
                                                })
                                              }
                                            }, 3000);
                                          }
                                        });
                                    }
                                  })
                                } else {
                                  Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                    response.data.info,
                                    'error'
                                  )
                                }

                                // if(type == 1){
                                //   var todayForm = new Date();
                                //   var yearForm = todayForm.getFullYear();
                                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                                //   this.formTitle = 'title_'+todayForm;
                                // } else {
                                //   this.formTitle = response.data.return_data.name;
                                // }

                                // this.showModal = true
                              } else {
                                let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_default_swal_text'];
                                if(response.data.info != '' && response.data.info != null){
                                  text = response.data.info
                                }
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['update_not_success_swal_title'],
                                  text,
                                  'error'
                                )
                              }
                            });
                        }
                      } else {
                        console.log('#33');
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['lead_messages']['not_creative_array_swal_text'],
                                    "error"
                                  )
                      }
                    } else {
                      console.log('#10');
                      axios
                        .post('https://test.autoturn.net/inside/api/target/data/campaign_update_v01.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          form_data: formData,
                          type: 'release',
                          target: 'edit_release_'+this.target,
                        }))
                        .then((response) => {
                          // console.log(response.data);
                          if(response.data.status == 'success'){
                            // console.log('#16');
                            // this.immediateList = response.data.return_data
                            // this.formData = response.data.return_data.form

                            if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                              let name = this.campaign_name;
                              let currency = this.currencyData.currency;
                              let addition = this.goalsData.form_addition;
                              let daily_budget = this.methodData.daily_budget;

                              let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                              if(this.methodData.Target_AD == true){
                                addition_text = '';
                              }
                              let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                              let campaignInfo = '';
                              Swal.fire({
                                // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_title'],
                                html: campaignInfo+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['yes_button'],
                                cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['no_button'],
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  // console.log(this.$route.params.id);

                                  this.releaseType = true
                                  this.style = 'z-index:100;';
                                  this.releasePercent = 5;
                                  let status = 1;
                                  let num = 0;
                                  let member_hash = this.$route.params.id;
                                  var bar5 = new ldBar("#myItem5");
                                  bar5.set(this.releasePercent);

                                  axios
                                    .post('https://test.autoturn.net/inside/api/campaign_release.php', Qs.stringify({
                                      s_code: member_hash,
                                      campaign_id: this.campaign_id,
                                    }))
                                    .then((caResponse) => {
                                      // console.log('caResponse:'+caResponse.data.return_data);
                                      if(caResponse.data.status == 'success'){
                                        // console.log('#17');
                                        //進行進度條
                                        // console.log('發佈莞成，開始跑進度條');
                                        setInterval( () => {
                                          num++;
                                          if(num < 1200){
                                            // console.log('num:'+num);
                                            // console.log(this.releaseType);

                                            if(this.releaseType == true){
                                              axios
                                                .post('https://test.autoturn.net/inside/api/campaign_states.php', Qs.stringify({
                                                  s_code: member_hash,
                                                  adaccount_id: this.adaccount_id,
                                                  campaign_id: this.campaign_id,
                                                }))
                                                .then((csResponse) => {
                                                  // console.log('csResponse:'+csResponse.data.return_data);
                                                  //進行進度條
                                                  if(status == 1){
                                                    if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                      Swal.fire({
                                                        icon: 'error',
                                                        title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                      }).then((result) => {

                                                      })
                                                    } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                      status = 0;

                                                      let postData = {adaccount_id: this.$route.params.adaccount_id};
                                                      let codeHash = ['de', 'di']

                                                      const data = new URLSearchParams();
                                                      data.append('s_code', this.$route.params.id);
                                                      data.append('post_data', JSON.stringify(postData));
                                                      data.append('code_hash', JSON.stringify(codeHash));
                                                      data.append('update_type', true);

                                                      // 發送請求
                                                      navigator.sendBeacon(
                                                        'https://test.autoturn.net/inside/api/update_cache.php',
                                                        data
                                                      );

                                                      axios
                                                        .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                          s_code: member_hash,
                                                          id: this.campaign_id,
                                                        }))
                                                        .then((response) => {
                                                          axios
                                                            .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
                                                            .then((csResponse) => {
                                                              this.releaseType = false

                                                              Swal.fire({
                                                                icon: 'success',
                                                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                                text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                                showDenyButton: false,
                                                                showCancelButton: false,
                                                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                                // timer: 5000
                                                                // denyButtonText: `Don't save`,
                                                              }).then((result) => {
                                                                /* Read more about isConfirmed, isDenied below */
                                                                if (result.isConfirmed) {
                                                                  // Swal.fire('Saved!', '', 'success')
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                                } else if (result.isDenied) {
                                                                  // Swal.fire('Changes are not saved', '', 'info')
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                                }

                                                                if (result.dismiss === Swal.DismissReason.timer) {
                                                                  this.allPageLoading = true
                                                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                                }
                                                              })
                                                            });
                                                        });
                                                    } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                      Swal.fire({
                                                        icon: 'error',
                                                        title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                        text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                        showDenyButton: false,
                                                        showCancelButton: false,
                                                        confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                      }).then((result) => {

                                                      })
                                                    } else {
                                                      this.releaseText = csResponse.data.return_data.info_text
                                                      this.releasePercent = csResponse.data.return_data.info_pct

                                                      bar5.set(this.releasePercent);
                                                      // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                      // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                      // console.log('this.releaseText:'+this.releaseText);
                                                      // console.log('this.releasePercent:'+this.releasePercent);

                                                      if(csResponse.data.return_data.info_pct == 100){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                      }
                                                    }
                                                  }
                                                });
                                            }
                                          } else {
                                            Swal.fire({
                                              icon: 'warning',
                                              title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                                              text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                                              showDenyButton: false,
                                              showCancelButton: false,
                                              confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                              timer: 1000
                                              // denyButtonText: `Don't save`,
                                            }).then((result) => {
                                              /* Read more about isConfirmed, isDenied below */
                                              if (result.isConfirmed) {
                                                // Swal.fire('Saved!', '', 'success')
                                                this.allPageLoading = true
                                                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                              } else if (result.isDenied) {
                                                // Swal.fire('Changes are not saved', '', 'info')
                                                this.allPageLoading = true
                                                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                              }

                                              if (result.dismiss === Swal.DismissReason.timer) {
                                                this.allPageLoading = true
                                                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                              }
                                            })
                                          }
                                        }, 3000);
                                      }
                                    });
                                }
                              })
                            } else {
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                                response.data.info,
                                'error'
                              )
                            }

                            // if(type == 1){
                            //   var todayForm = new Date();
                            //   var yearForm = todayForm.getFullYear();
                            //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                            //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                            //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                            //   todayForm = yearForm + monthForm + dateForm + timeForm;

                            //   this.formTitle = 'title_'+todayForm;
                            // } else {
                            //   this.formTitle = response.data.return_data.name;
                            // }

                            // this.showModal = true
                          } else {
                            let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['update_not_success_default_swal_text'];
                            if(response.data.info != '' && response.data.info != null){
                              text = response.data.info
                            }
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['warning']['not_lead_messages']['update_not_success_swal_title'],
                              text,
                              'error'
                            )
                          }
                        });
                    }
                  });
                }

                if(caResponse.data.status == 'success'){
                  // console.log('#18');
                  var daily_keyword_split_budget = this.methodData.Budget_KW;
                  var daily_demo_budget = this.methodData.Budget_DM;
                  var budget_addition = this.goalsData.form_addition;

                  if(this.dateData.start_date != "" && this.dateData.end_date != ""){
                      var d1 = new Date(this.dateData.start_date);
                      var d2 = new Date(this.dateData.end_date);
                      var days = parseInt((d2-d1)/86400000) + parseInt(1);
                  } else {
                      var days = 0;
                  }

                  var keyword_split_budget = 0;
                  if(this.methodData.Budget_KW != ''){
                      keyword_split_budget = Math.round(this.methodData.Budget_KW * days * (1+(budget_addition/100)));
                  }

                  var demo_budget = 0;
                  if(this.methodData.Budget_DM != ''){
                      demo_budget = this.methodData.Budget_DM * days;
                  }

                  var _tmp_audience_budget = 0;
                  var audience_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.5)');
                  _tmp_audience_budget = this.methodData.Budget_LA;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.5);
                  // console.log('Math.round('+_tmp_audience_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  audience_budget = Math.round(_tmp_audience_budget * days * (1+(budget_addition/100)));

                  var _tmp_marketing_again_budget = 0;
                  var marketing_again_budget = 0;
                  // console.log('Math.round(('+daily_keyword_split_budget +'+'+ daily_demo_budget+')*0.25)');
                  _tmp_marketing_again_budget = this.methodData.Budget_RT;//Math.round((daily_keyword_split_budget + daily_demo_budget)*0.25);
                  // console.log('Math.round('+_tmp_marketing_again_budget +'*'+ days +'* (1+('+budget_addition+'/100)))');
                  marketing_again_budget = Math.round(_tmp_marketing_again_budget * days * (1+(budget_addition/100)));

                  // console.log(parseInt(keyword_split_budget)+' + '+parseInt(demo_budget)+' + '+parseInt(audience_budget)+' + '+parseInt(marketing_again_budget));
                  var html = parseInt(keyword_split_budget) + parseInt(demo_budget) + parseInt(audience_budget) + parseInt(marketing_again_budget);

                  if(isNaN(html)){
                      html = '0';
                  }

                  this.total_budget = html;

                  let _tmp_goalsData = this.goalsData;
                  const _view_goalsData = JSON.parse(JSON.stringify(_tmp_goalsData));
                  let _tmp_exAudiencesData = this.exAudiencesData;
                  const _view_exAudiencesData = JSON.parse(JSON.stringify(_tmp_exAudiencesData));

                  // console.log(_tmp_exAudiencesData);

                  delete _view_goalsData['objective_list'];
                  delete _view_exAudiencesData['custom_excluded_audiences'];

                  let formData = {
                    campaign_id: this.campaign_id,
                    campaign_name: this.campaign_name,
                    adaccount_id: this.adaccount_id,
                    optimizedData: this.optimizedData,
                    Budget_KW_result: this.Budget_KW_result,
                    total_budget: this.total_budget,
                    useDefaultLayout: this.useDefaultLayout,
                    dynBudgetData: this.dynBudgetData,
                    methodData: this.methodData,
                    benefitsAndInvestmentData: this.benefitsAndInvestmentData,
                    dateData: this.dateData,
                    goalsData: _view_goalsData,
                    regionsData: this.regionsData,
                    selectCountries: this.selectCountries,
                    selectLangs: this.selectLangs,
                    // exAudiencesData: _view_exAudiencesData,
                    pdData: this.pdData,
                    idData: this.idData,
                    postData: this.postData,
                    adMaterialData: this.adMaterialDataNew
                  }

                  let adaccount_id = this.adaccount_id

                  if(this.goalsData.campaign_objective == 'LEAD_GENERATION' || this.goalsData.campaign_objective == 'MESSAGES'){
                    // console.log('#1');
                    let materialType = 0;
                    let selectArticleLength = 0;

                    console.log('this.postData');
                    console.log(this.postData);
                    console.log('this.adMaterialDataNew');
                    console.log(this.adMaterialDataNew);

                    console.log('b this.postData.select_article');
                    console.log(this.postData.select_article);
                    console.log('b this.postData.select_creatives_message');
                    console.log(this.postData.select_creatives_message);
                    console.log('b this.postData.select_creatives_adset_ads_message');
                    console.log(this.postData.select_creatives_adset_ads_message);
                    console.log('b this.adMaterialDataNew.creative_array');
                    console.log(this.adMaterialDataNew.creative_array);

                    if(this.postData.select_article != '' && this.postData.select_article != null && typeof this.postData.select_article != 'undefined'){
                      selectArticleLength = this.postData.select_article.length;
                    }

                    let selectCreativesMessageLength = 0;
                    if(this.postData.select_creatives_message != '' && this.postData.select_creatives_message != null && typeof this.postData.select_creatives_message != 'undefined'){
                      selectCreativesMessageLength = this.postData.select_creatives_message.length;
                    }

                    let selectCreativesAdsetAdsMessageLength = 0;
                    if(this.postData.select_creatives_adset_ads_message != '' && this.postData.select_creatives_adset_ads_message != null && typeof this.postData.select_creatives_adset_ads_message != 'undefined'){
                      selectCreativesAdsetAdsMessageLength = this.postData.select_creatives_adset_ads_message.length;
                    }

                    let creativeArrayLength = 0;
                    if(this.adMaterialDataNew.creative_array != '' && this.adMaterialDataNew.creative_array != null && typeof this.adMaterialDataNew.creative_array != 'undefined'){
                      creativeArrayLength = this.adMaterialDataNew.creative_array.length;
                    }

                    console.log('a selectArticleLength');
                    console.log(selectArticleLength);
                    console.log('a selectCreativesMessageLength');
                    console.log(selectCreativesMessageLength);
                    console.log('a selectCreativesAdsetAdsMessageLength');
                    console.log(selectCreativesAdsetAdsMessageLength);
                    console.log('a creativeArrayLength');
                    console.log(creativeArrayLength);
                    console.log('a this.goalsData.campaign_objective');
                    console.log(this.goalsData.campaign_objective);

                    if(creativeArrayLength == 0 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                      materialType = 1;
                    } else if(selectArticleLength == 0 && selectCreativesMessageLength == 0 && selectCreativesAdsetAdsMessageLength == 0 && creativeArrayLength == 0 && this.goalsData.campaign_objective == 'MESSAGES'){
                      materialType = 2;
                    }

                    console.log('this.postData.select_article');
                    console.log(this.postData.select_article);
                    console.log('this.postData.select_creatives_message');
                    console.log(this.postData.select_creatives_message);
                    console.log('this.adMaterialDataNew.creative_array');
                    console.log(this.adMaterialDataNew.creative_array);
                    console.log('this.goalsData.campaign_objective');
                    console.log(this.goalsData.campaign_objective);
                    console.log(selectArticleLength +' == 0 && '+ selectCreativesMessageLength +' == 0 && '+ creativeArrayLength +' == 0');

                    console.log('#4 materialType:'+materialType);

                    if(materialType == 0){
                      // console.log('#2');
                      let message_sr_i = 0;
                      let form_sr_i = 0;
                      let message = 0;
                      let single_object_spec = 0;
                      let single_title = 0;
                      let materials_item = 0;
                      let materials_object_spec = 0;
                      let materials_title = 0;
                      let ad_name = 0;

                      for(let i = 0; i < this.adMaterialDataNew.creative_array.length; i++){
                        if(this.adMaterialDataNew.creative_array[i].title == '' || this.adMaterialDataNew.creative_array[i].title == null || typeof this.adMaterialDataNew.creative_array[i].title == 'undefined'){
                          ad_name = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].type == 2){
                          let materials_length = this.adMaterialDataNew.creative_array[i].materials.length

                          if(materials_length < 2){
                            materials_item = 1;
                          } else {
                            for(let j = 0; j < materials_length; j++){
                              if(this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].object_spec.id == 'undefined'){
                                materials_object_spec = 1;
                              }

                              if(this.adMaterialDataNew.creative_array[i].materials[j].title == '' || this.adMaterialDataNew.creative_array[i].materials[j].title == null || typeof this.adMaterialDataNew.creative_array[i].materials[j].title == 'undefined'){
                                materials_title = 1;
                              }
                            }
                          }
                        }

                        if(this.adMaterialDataNew.creative_array[i].type == 1){
                          if(this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].object_spec.id == 'undefined'){
                            single_object_spec = 1;
                          }

                          if(this.adMaterialDataNew.creative_array[i].materialSingle[0].title == '' || this.adMaterialDataNew.creative_array[i].materialSingle[0].title == null || typeof this.adMaterialDataNew.creative_array[i].materialSingle[0].title == 'undefined'){
                            single_title = 1;
                          }
                        }

                        if(this.adMaterialDataNew.creative_array[i].message == '' || this.adMaterialDataNew.creative_array[i].message == null || typeof this.adMaterialDataNew.creative_array[i].message == 'undefined'){
                          message = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].form_sr_i == '' || this.adMaterialDataNew.creative_array[i].form_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].form_sr_i == 'undefined'){
                          form_sr_i = 1;
                        }

                        if(this.adMaterialDataNew.creative_array[i].message_sr_i == '' || this.adMaterialDataNew.creative_array[i].message_sr_i == null || typeof this.adMaterialDataNew.creative_array[i].message_sr_i == 'undefined'){
                          message_sr_i = 1;
                        }
                      }

                      if(ad_name == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_ad_name_swal_text'],
                                    "error"
                                  )
                      } else if(single_object_spec == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_single_object_spec_swal_text'],
                                    "error"
                                  )
                      } else if(single_title == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_single_title_swal_text'],
                                    "error"
                                  )
                      } else if(materials_item == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_item_swal_text'],
                                    "error"
                                  )
                      } else if(materials_object_spec == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_object_spec_swal_text'],
                                    "error"
                                  )
                      } else if(materials_title == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_materials_title_swal_text'],
                                    "error"
                                  )
                      } else if(message == 1){
                        Swal.fire(
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                    this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_message_swal_text'],
                                    "error"
                                  )
                      } else if(form_sr_i == 1 && this.goalsData.campaign_objective == 'LEAD_GENERATION'){
                        Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_form_sr_i_swal_text'],
                                  "error"
                                )
                      } else if(message_sr_i == 1 && this.goalsData.campaign_objective == 'MESSAGES'){
                        Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_message_sr_i_swal_text'],
                                  "error"
                                )
                      } else {
                        console.log('#11');
                        axios
                          .post('https://test.autoturn.net/inside/api/target/data/campaign_update_v01.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            form_data: formData,
                            type: 'release',
                            target: 'edit_release_'+this.target,
                          }))
                          .then((response) => {
                            // console.log(response.data);
                            if(response.data.status == 'success'){
                              // console.log('#19');
                              // this.immediateList = response.data.return_data
                              // this.formData = response.data.return_data.form

                              if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                                let name = this.campaign_name;
                                let currency = this.currencyData.currency;
                                let addition = this.goalsData.form_addition;
                                let daily_budget = this.methodData.daily_budget;

                                let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['addition_text']+'<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                                if(this.methodData.Target_AD == true){
                                  addition_text = '';
                                }
                                let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                                let campaignInfo = '';

                                Swal.fire({
                                  // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_title'],
                                  html: campaignInfo+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['swal_text_c'],
                                  icon: 'warning',
                                  showCancelButton: true,
                                  confirmButtonColor: '#3085d6',
                                  cancelButtonColor: '#d33',
                                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['yes_button'],
                                  cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['no_button'],
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    // console.log(this.$route.params.id);

                                    this.releaseType = true
                                    this.style = 'z-index:100;';
                                    this.releasePercent = 5;
                                    let status = 1;
                                    let num = 0;
                                    let member_hash = this.$route.params.id;
                                    var bar5 = new ldBar("#myItem5");
                                    bar5.set(this.releasePercent);

                                    axios
                                      .post('https://test.autoturn.net/inside/api/campaign_release.php', Qs.stringify({
                                        s_code: member_hash,
                                        campaign_id: this.campaign_id,
                                      }))
                                      .then((caResponse) => {
                                        // console.log('caResponse:'+caResponse.data.return_data);
                                        if(caResponse.data.status == 'success'){
                                          // console.log('#20');
                                          //進行進度條
                                          // console.log('發佈莞成，開始跑進度條');
                                          setInterval( () => {
                                            num++;
                                            if(num < 1200){
                                              // console.log('num:'+num);
                                              // console.log(this.releaseType);

                                              if(this.releaseType == true){
                                                axios
                                                  .post('https://test.autoturn.net/inside/api/campaign_states.php', Qs.stringify({
                                                    s_code: member_hash,
                                                    adaccount_id: this.adaccount_id,
                                                    campaign_id: this.campaign_id,
                                                  }))
                                                  .then((csResponse) => {
                                                    // console.log('csResponse:'+csResponse.data.return_data);
                                                    //進行進度條
                                                    if(status == 1){
                                                      if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                        Swal.fire({
                                                          icon: 'error',
                                                          title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                          text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                          showDenyButton: false,
                                                          showCancelButton: false,
                                                          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                        }).then((result) => {
                                                          console.log('#1');
                                                          let info_text = csResponse.data.return_data.info_text;
                                                          let tosStatus = info_text.includes("/leadgen/tos");
                                                          if(tosStatus == true){
                                                            window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                          }
                                                        })
                                                      } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                        status = 0;

                                                        let postData = {adaccount_id: this.$route.params.adaccount_id};
                                                        let codeHash = ['de', 'di']

                                                        const data = new URLSearchParams();
                                                        data.append('s_code', this.$route.params.id);
                                                        data.append('post_data', JSON.stringify(postData));
                                                        data.append('code_hash', JSON.stringify(codeHash));
                                                        data.append('update_type', true);

                                                        // 發送請求
                                                        navigator.sendBeacon(
                                                          'https://test.autoturn.net/inside/api/update_cache.php',
                                                          data
                                                        );

                                                        axios
                                                          .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                            s_code: member_hash,
                                                            id: this.campaign_id,
                                                          }))
                                                          .then((response) => {
                                                            axios
                                                              .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
                                                              .then((csResponse) => {
                                                                this.releaseType = false

                                                                Swal.fire({
                                                                  icon: 'success',
                                                                  title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                                  text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                                  showDenyButton: false,
                                                                  showCancelButton: false,
                                                                  confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                                  // timer: 5000
                                                                  // denyButtonText: `Don't save`,
                                                                }).then((result) => {
                                                                  /* Read more about isConfirmed, isDenied below */
                                                                  if (result.isConfirmed) {
                                                                    // Swal.fire('Saved!', '', 'success')
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                                  } else if (result.isDenied) {
                                                                    // Swal.fire('Changes are not saved', '', 'info')
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                                  }

                                                                  if (result.dismiss === Swal.DismissReason.timer) {
                                                                    this.allPageLoading = true
                                                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                                  }
                                                                })
                                                              });
                                                          });
                                                      } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                        this.releaseType = false
                                                        this.style = 'z-index:-1;';
                                                        bar5.set(0);
                                                        status = 0;
                                                        Swal.fire({
                                                          icon: 'error',
                                                          title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                          text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                          showDenyButton: false,
                                                          showCancelButton: false,
                                                          confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                        }).then((result) => {
                                                          console.log('#2');
                                                          let info_text = csResponse.data.return_data.info_text;
                                                          let tosStatus = info_text.includes("/leadgen/tos");
                                                          if(tosStatus == true){
                                                            window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                          }
                                                        })
                                                      } else {
                                                        this.releaseText = csResponse.data.return_data.info_text
                                                        this.releasePercent = csResponse.data.return_data.info_pct

                                                        bar5.set(this.releasePercent);
                                                        // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                        // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                        // console.log('this.releaseText:'+this.releaseText);
                                                        // console.log('this.releasePercent:'+this.releasePercent);

                                                        if(csResponse.data.return_data.info_pct == 100){
                                                          this.releaseType = false
                                                          this.style = 'z-index:-1;';
                                                          bar5.set(0);
                                                          status = 0;
                                                        }
                                                      }
                                                    }
                                                  });
                                              }
                                            } else {
                                              Swal.fire({
                                                icon: 'warning',
                                                title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_title'],
                                                text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['swal_html'],
                                                showDenyButton: false,
                                                showCancelButton: false,
                                                confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                                timer: 1000
                                                // denyButtonText: `Don't save`,
                                              }).then((result) => {
                                                /* Read more about isConfirmed, isDenied below */
                                                if (result.isConfirmed) {
                                                  // Swal.fire('Saved!', '', 'success')
                                                  this.allPageLoading = true
                                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                } else if (result.isDenied) {
                                                  // Swal.fire('Changes are not saved', '', 'info')
                                                  this.allPageLoading = true
                                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                }

                                                if (result.dismiss === Swal.DismissReason.timer) {
                                                  this.allPageLoading = true
                                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                }
                                              })
                                            }
                                          }, 3000);
                                        }
                                      });
                                  }
                                })
                              } else {
                                Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['campaign_update']['not_success']['swal_title'],
                                  response.data.info,
                                  'error'
                                )
                              }

                              // if(type == 1){
                              //   var todayForm = new Date();
                              //   var yearForm = todayForm.getFullYear();
                              //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                              //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                              //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                              //   todayForm = yearForm + monthForm + dateForm + timeForm;

                              //   this.formTitle = 'title_'+todayForm;
                              // } else {
                              //   this.formTitle = response.data.return_data.name;
                              // }

                              // this.showModal = true
                            } else {
                              let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_default_swal_text'];
                              if(response.data.info != '' && response.data.info != null){
                                text = response.data.info
                              }
                              Swal.fire(
                                this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['update_not_success_swal_title'],
                                text,
                                'error'
                              )
                            }
                          });
                      }
                    } else {
                      console.log('#34');
                      Swal.fire(
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_title'],
                                  this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['lead_messages']['not_creative_array_swal_text'],
                                  "error"
                                )
                    }
                  } else {
                    console.log('#12');
                    axios
                      .post('https://test.autoturn.net/inside/api/target/data/campaign_update_v01.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        form_data: formData,
                        type: 'release',
                        target: 'edit_release_'+this.target,
                      }))
                      .then((response) => {
                        // console.log(response.data);
                        if(response.data.status == 'success'){
                          // console.log('#19');
                          // this.immediateList = response.data.return_data
                          // this.formData = response.data.return_data.form

                          if(response.data.release_status == 'N' && response.data.release_writing_status == 'draft'){
                            let name = this.campaign_name;
                            let currency = this.currencyData.currency;
                            let addition = this.goalsData.form_addition;
                            let daily_budget = this.methodData.daily_budget;

                            let addition_text = '（'+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['addition_text']+'：<span style="color:red; font-weight:bold;">'+addition+'%</span>）';
                            if(this.methodData.Target_AD == true){
                              addition_text = '';
                            }
                            let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(addition/100)));
                            let campaignInfo = '';

                            Swal.fire({
                              // title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_title']+"「"+name+"」",
                              title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_title'],
                              html: campaignInfo+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_a']+"<span style='color:red;'>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_b']+"</span>"+this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['swal_text_c'],
                              icon: 'warning',
                              showCancelButton: true,
                              confirmButtonColor: '#3085d6',
                              cancelButtonColor: '#d33',
                              confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['yes_button'],
                              cancelButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['no_button'],
                            }).then((result) => {
                              if (result.isConfirmed) {
                                // console.log(this.$route.params.id);

                                this.releaseType = true
                                this.style = 'z-index:100;';
                                this.releasePercent = 5;
                                let status = 1;
                                let num = 0;
                                let member_hash = this.$route.params.id;
                                var bar5 = new ldBar("#myItem5");
                                bar5.set(this.releasePercent);

                                axios
                                  .post('https://test.autoturn.net/inside/api/campaign_release.php', Qs.stringify({
                                    s_code: member_hash,
                                    campaign_id: this.campaign_id,
                                  }))
                                  .then((caResponse) => {
                                    // console.log('caResponse:'+caResponse.data.return_data);
                                    if(caResponse.data.status == 'success'){
                                      // console.log('#20');
                                      //進行進度條
                                      // console.log('發佈莞成，開始跑進度條');
                                      setInterval( () => {
                                        num++;
                                        if(num < 1200){
                                          // console.log('num:'+num);
                                          // console.log(this.releaseType);

                                          if(this.releaseType == true){
                                            axios
                                              .post('https://test.autoturn.net/inside/api/campaign_states.php', Qs.stringify({
                                                s_code: member_hash,
                                                adaccount_id: this.adaccount_id,
                                                campaign_id: this.campaign_id,
                                              }))
                                              .then((csResponse) => {
                                                // console.log('csResponse:'+csResponse.data.return_data);
                                                //進行進度條
                                                if(status == 1){
                                                  if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                    this.releaseType = false
                                                    this.style = 'z-index:-1;';
                                                    bar5.set(0);
                                                    status = 0;
                                                    Swal.fire({
                                                      icon: 'error',
                                                      title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_title'],
                                                      text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                      showDenyButton: false,
                                                      showCancelButton: false,
                                                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_failure']['confirm_button']
                                                    }).then((result) => {
                                                      console.log('#3');
                                                      let info_text = csResponse.data.return_data.info_text;
                                                      let tosStatus = info_text.includes("/leadgen/tos");
                                                      if(tosStatus == true){
                                                        window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                      }
                                                    })
                                                  } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                                    status = 0;

                                                    let postData = {adaccount_id: this.$route.params.adaccount_id};
                                                    let codeHash = ['de', 'di']

                                                    const data = new URLSearchParams();
                                                    data.append('s_code', this.$route.params.id);
                                                    data.append('post_data', JSON.stringify(postData));
                                                    data.append('code_hash', JSON.stringify(codeHash));
                                                    data.append('update_type', true);

                                                    // 發送請求
                                                    navigator.sendBeacon(
                                                      'https://test.autoturn.net/inside/api/update_cache.php',
                                                      data
                                                    );

                                                    axios
                                                      .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                                        s_code: member_hash,
                                                        id: this.campaign_id,
                                                      }))
                                                      .then((response) => {
                                                        axios
                                                          .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+this.campaign_id)
                                                          .then((csResponse) => {
                                                            this.releaseType = false

                                                            Swal.fire({
                                                              icon: 'success',
                                                              title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_title'],
                                                              text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['swal_html'],
                                                              showDenyButton: false,
                                                              showCancelButton: false,
                                                              confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['info_state_success']['confirm_button'],
                                                              // timer: 5000
                                                              // denyButtonText: `Don't save`,
                                                            }).then((result) => {
                                                              /* Read more about isConfirmed, isDenied below */
                                                              if (result.isConfirmed) {
                                                                // Swal.fire('Saved!', '', 'success')
                                                                this.allPageLoading = true
                                                                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                              } else if (result.isDenied) {
                                                                // Swal.fire('Changes are not saved', '', 'info')
                                                                this.allPageLoading = true
                                                                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                              }

                                                              if (result.dismiss === Swal.DismissReason.timer) {
                                                                this.allPageLoading = true
                                                                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                              }
                                                            })
                                                          });
                                                      });
                                                  } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                                    this.releaseType = false
                                                    this.style = 'z-index:-1;';
                                                    bar5.set(0);
                                                    status = 0;
                                                    Swal.fire({
                                                      icon: 'error',
                                                      title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_title'],
                                                      text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['swal_html']+csResponse.data.return_data.info_text,
                                                      showDenyButton: false,
                                                      showCancelButton: false,
                                                      confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['state_failure']['confirm_button']
                                                    }).then((result) => {
                                                      console.log('#4');
                                                      let info_text = csResponse.data.return_data.info_text;
                                                      let tosStatus = info_text.includes("/leadgen/tos");
                                                      if(tosStatus == true){
                                                        window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                                      }
                                                    })
                                                  } else {
                                                    this.releaseText = csResponse.data.return_data.info_text
                                                    this.releasePercent = csResponse.data.return_data.info_pct

                                                    bar5.set(this.releasePercent);
                                                    // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                                    // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                                    // console.log('this.releaseText:'+this.releaseText);
                                                    // console.log('this.releasePercent:'+this.releasePercent);

                                                    if(csResponse.data.return_data.info_pct == 100){
                                                      this.releaseType = false
                                                      this.style = 'z-index:-1;';
                                                      bar5.set(0);
                                                      status = 0;
                                                    }
                                                  }
                                                }
                                              });
                                          }
                                        } else {
                                          Swal.fire({
                                            icon: 'warning',
                                            title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_title'],
                                            text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['swal_html'],
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['success']['else']['confirm_button'],
                                            timer: 1000
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            }
                                          })
                                        }
                                      }, 3000);
                                    }
                                  });
                              }
                            })
                          } else {
                            Swal.fire(
                              this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['campaign_update']['not_success']['swal_title'],
                              response.data.info,
                              'error'
                            )
                          }

                          // if(type == 1){
                          //   var todayForm = new Date();
                          //   var yearForm = todayForm.getFullYear();
                          //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                          //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                          //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                          //   todayForm = yearForm + monthForm + dateForm + timeForm;

                          //   this.formTitle = 'title_'+todayForm;
                          // } else {
                          //   this.formTitle = response.data.return_data.name;
                          // }

                          // this.showModal = true
                        } else {
                          let text = this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['update_not_success_default_swal_text'];
                          if(response.data.info != '' && response.data.info != null){
                            text = response.data.info
                          }
                          Swal.fire(
                            this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['success']['not_lead_messages']['update_not_success_swal_title'],
                            text,
                            'error'
                          )
                        }
                      });
                  }
                }

                if(caResponse.data.status == 'login'){
                  Swal.fire({
                    icon: 'error',
                    title: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['swal_title'],
                    text: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.showLang[this.selectLang]['views']['Event']['methods']['release']['axios']['campaign_member_status']['login']['confirm_button']
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      // this.allPageLoading = true
                      window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      // this.allPageLoading = true
                      window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
                    }
                  })
                }
              });
          }
        }
      },
      methodName(value){
        switch(value){
          case 'META_TEST':
            return '測試素材';
            break;
          case 'META_KW':
            return '精準興趣';
            break;
          case 'META_LA':
            return '類似受眾';
            break;
          case 'META_RT':
            return '再行銷';
            break;
          case 'META_ASC':
            return 'ASC';
            break;
        }
      },
      objectiveName(value){
        switch(value){
          case 'CONVERSIONS':
            return '轉換次數';
            break;
          case 'LINK_CLICKS':
            return '流量';
            break;
          case 'POST_ENGAGEMENT':
            return '互動';
            break;
          case 'VIDEO_VIEWS':
            return '觀看影片';
            break;
          case 'LEAD_GENERATION':
            return '開發潛在顧客';
            break;
          case 'MESSAGES':
            return '發送訊息';
            break;
          case 'PRODUCT_CATALOG_SALES':
            return '目錄銷售';
            break;
        }
      },
    },
    mounted () {
      // document.title = '行銷活動修改頁 - AutoTurn';
    }
  }
</script>

<style lang="scss" scope>
  .progressbar {
    background: linear-gradient(270.01deg, #1D619F 0%, #7FDCFA 51.04%, #7AD5C0 76.56%);
    border-radius: 6px;
  }

  .table {
    display: flex;
    flex-wrap: wrap;
    width: 600px; /* 表格的寬度 */
    border: 1px solid #ccc; /* 表格邊框 */
  }
  .return_table {
    display: flex;
    flex-wrap: wrap;
    width: 800px; /* 表格的寬度 */
  }
  .row, .return_row {
    display: flex;
    width: 100%;
  }
  .cell, .cell_stage {
    width: 33.33%;
    height: auto; /* 單元格的高度 */
    border: 1px solid #ccc; /* 單元格邊框 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 18px 4px;
  }
  .cell_content {
    width: 66.67%;
    height: auto; /* 單元格的高度 */
    border: 1px solid #ccc; /* 單元格邊框 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 18px 4px;
  }
  .header, .return_header {
    background-color: #CBD5E1;
  }
</style>
